(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('ractive')) :
	typeof define === 'function' && define.amd ? define(['ractive'], factory) :
	(global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.app = factory(global.Ractive));
})(this, (function (ractive) { 'use strict';

	function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

	var ractive__default = /*#__PURE__*/_interopDefaultLegacy(ractive);

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	function getCjsExportFromNamespace (n) {
		return n && n['default'] || n;
	}

	var check = function (it) {
	  return it && it.Math === Math && it;
	};

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis_1 =
	// eslint-disable-next-line es/no-global-this -- safe
	check(typeof globalThis == 'object' && globalThis) || check(typeof window == 'object' && window) ||
	// eslint-disable-next-line no-restricted-globals -- safe
	check(typeof self == 'object' && self) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) || check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
	// eslint-disable-next-line no-new-func -- fallback
	function () {
	  return this;
	}() || Function('return this')();

	var fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (error) {
	    return true;
	  }
	};

	// Detect IE8's incomplete defineProperty implementation
	var descriptors = !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty({}, 1, {
	    get: function () {
	      return 7;
	    }
	  })[1] !== 7;
	});

	var functionBindNative = !fails(function () {
	  // eslint-disable-next-line es/no-function-prototype-bind -- safe
	  var test = function () {/* empty */}.bind();
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return typeof test != 'function' || test.hasOwnProperty('prototype');
	});

	var call$2 = Function.prototype.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	var functionCall = functionBindNative ? call$2.bind(call$2) : function () {
	  return call$2.apply(call$2, arguments);
	};

	var $propertyIsEnumerable = {}.propertyIsEnumerable;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$3 = Object.getOwnPropertyDescriptor;

	// Nashorn ~ JDK8 bug
	var NASHORN_BUG = getOwnPropertyDescriptor$3 && !$propertyIsEnumerable.call({
	  1: 2
	}, 1);

	// `Object.prototype.propertyIsEnumerable` method implementation
	// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
	var f$5 = NASHORN_BUG ? function propertyIsEnumerable(V) {
	  var descriptor = getOwnPropertyDescriptor$3(this, V);
	  return !!descriptor && descriptor.enumerable;
	} : $propertyIsEnumerable;
	var objectPropertyIsEnumerable = {
	  f: f$5
	};

	var createPropertyDescriptor = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var FunctionPrototype$2 = Function.prototype;
	var call$1 = FunctionPrototype$2.call;
	// eslint-disable-next-line es/no-function-prototype-bind -- safe
	var uncurryThisWithBind = functionBindNative && FunctionPrototype$2.bind.bind(call$1, call$1);
	var functionUncurryThis = functionBindNative ? uncurryThisWithBind : function (fn) {
	  return function () {
	    return call$1.apply(fn, arguments);
	  };
	};

	var toString$1 = functionUncurryThis({}.toString);
	var stringSlice = functionUncurryThis(''.slice);
	var classofRaw = function (it) {
	  return stringSlice(toString$1(it), 8, -1);
	};

	var $Object$4 = Object;
	var split = functionUncurryThis(''.split);

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var indexedObject = fails(function () {
	  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
	  // eslint-disable-next-line no-prototype-builtins -- safe
	  return !$Object$4('z').propertyIsEnumerable(0);
	}) ? function (it) {
	  return classofRaw(it) === 'String' ? split(it, '') : $Object$4(it);
	} : $Object$4;

	// we can't use just `it == null` since of `document.all` special case
	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
	var isNullOrUndefined = function (it) {
	  return it === null || it === undefined;
	};

	var $TypeError$d = TypeError;

	// `RequireObjectCoercible` abstract operation
	// https://tc39.es/ecma262/#sec-requireobjectcoercible
	var requireObjectCoercible = function (it) {
	  if (isNullOrUndefined(it)) throw new $TypeError$d("Can't call method on " + it);
	  return it;
	};

	// toObject with fallback for non-array-like ES3 strings

	var toIndexedObject = function (it) {
	  return indexedObject(requireObjectCoercible(it));
	};

	// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
	var documentAll = typeof document == 'object' && document.all;

	// `IsCallable` abstract operation
	// https://tc39.es/ecma262/#sec-iscallable
	// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
	var isCallable = typeof documentAll == 'undefined' && documentAll !== undefined ? function (argument) {
	  return typeof argument == 'function' || argument === documentAll;
	} : function (argument) {
	  return typeof argument == 'function';
	};

	var isObject = function (it) {
	  return typeof it == 'object' ? it !== null : isCallable(it);
	};

	var aFunction = function (argument) {
	  return isCallable(argument) ? argument : undefined;
	};
	var getBuiltIn = function (namespace, method) {
	  return arguments.length < 2 ? aFunction(globalThis_1[namespace]) : globalThis_1[namespace] && globalThis_1[namespace][method];
	};

	var objectIsPrototypeOf = functionUncurryThis({}.isPrototypeOf);

	var navigator = globalThis_1.navigator;
	var userAgent = navigator && navigator.userAgent;
	var environmentUserAgent = userAgent ? String(userAgent) : '';

	var process = globalThis_1.process;
	var Deno = globalThis_1.Deno;
	var versions = process && process.versions || Deno && Deno.version;
	var v8 = versions && versions.v8;
	var match, version;
	if (v8) {
	  match = v8.split('.');
	  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
	  // but their correct versions are not interesting for us
	  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
	}

	// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
	// so check `userAgent` even if `.v8` exists, but 0
	if (!version && environmentUserAgent) {
	  match = environmentUserAgent.match(/Edge\/(\d+)/);
	  if (!match || match[1] >= 74) {
	    match = environmentUserAgent.match(/Chrome\/(\d+)/);
	    if (match) version = +match[1];
	  }
	}
	var environmentV8Version = version;

	/* eslint-disable es/no-symbol -- required for testing */

	var $String$4 = globalThis_1.String;

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
	var symbolConstructorDetection = !!Object.getOwnPropertySymbols && !fails(function () {
	  var symbol = Symbol('symbol detection');
	  // Chrome 38 Symbol has incorrect toString conversion
	  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
	  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
	  // of course, fail.
	  return !$String$4(symbol) || !(Object(symbol) instanceof Symbol) ||
	  // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
	  !Symbol.sham && environmentV8Version && environmentV8Version < 41;
	});

	/* eslint-disable es/no-symbol -- required for testing */

	var useSymbolAsUid = symbolConstructorDetection && !Symbol.sham && typeof Symbol.iterator == 'symbol';

	var $Object$3 = Object;
	var isSymbol = useSymbolAsUid ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  var $Symbol = getBuiltIn('Symbol');
	  return isCallable($Symbol) && objectIsPrototypeOf($Symbol.prototype, $Object$3(it));
	};

	var $String$3 = String;
	var tryToString = function (argument) {
	  try {
	    return $String$3(argument);
	  } catch (error) {
	    return 'Object';
	  }
	};

	var $TypeError$c = TypeError;

	// `Assert: IsCallable(argument) is true`
	var aCallable = function (argument) {
	  if (isCallable(argument)) return argument;
	  throw new $TypeError$c(tryToString(argument) + ' is not a function');
	};

	// `GetMethod` abstract operation
	// https://tc39.es/ecma262/#sec-getmethod
	var getMethod = function (V, P) {
	  var func = V[P];
	  return isNullOrUndefined(func) ? undefined : aCallable(func);
	};

	var $TypeError$b = TypeError;

	// `OrdinaryToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-ordinarytoprimitive
	var ordinaryToPrimitive = function (input, pref) {
	  var fn, val;
	  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  if (isCallable(fn = input.valueOf) && !isObject(val = functionCall(fn, input))) return val;
	  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = functionCall(fn, input))) return val;
	  throw new $TypeError$b("Can't convert object to primitive value");
	};

	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var defineProperty$1 = Object.defineProperty;
	var defineGlobalProperty = function (key, value) {
	  try {
	    defineProperty$1(globalThis_1, key, {
	      value: value,
	      configurable: true,
	      writable: true
	    });
	  } catch (error) {
	    globalThis_1[key] = value;
	  }
	  return value;
	};

	var sharedStore = createCommonjsModule(function (module) {

	  var SHARED = '__core-js_shared__';
	  var store = module.exports = globalThis_1[SHARED] || defineGlobalProperty(SHARED, {});
	  (store.versions || (store.versions = [])).push({
	    version: '3.49.0',
	    mode: 'global',
	    copyright: '© 2013–2025 Denis Pushkarev (zloirock.ru), 2025–2026 CoreJS Company (core-js.io). All rights reserved.',
	    license: 'https://github.com/zloirock/core-js/blob/v3.49.0/LICENSE',
	    source: 'https://github.com/zloirock/core-js'
	  });
	});

	var shared = function (key, value) {
	  return sharedStore[key] || (sharedStore[key] = value || {});
	};

	var $Object$2 = Object;

	// `ToObject` abstract operation
	// https://tc39.es/ecma262/#sec-toobject
	var toObject = function (argument) {
	  return $Object$2(requireObjectCoercible(argument));
	};

	var hasOwnProperty = functionUncurryThis({}.hasOwnProperty);

	// `HasOwnProperty` abstract operation
	// https://tc39.es/ecma262/#sec-hasownproperty
	// eslint-disable-next-line es/no-object-hasown -- safe
	var hasOwnProperty_1 = Object.hasOwn || function hasOwn(it, key) {
	  return hasOwnProperty(toObject(it), key);
	};

	var id = 0;
	var postfix = Math.random();
	var toString = functionUncurryThis(1.1.toString);
	var uid = function (key) {
	  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
	};

	var Symbol$1 = globalThis_1.Symbol;
	var WellKnownSymbolsStore = shared('wks');
	var createWellKnownSymbol = useSymbolAsUid ? Symbol$1['for'] || Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;
	var wellKnownSymbol = function (name) {
	  if (!hasOwnProperty_1(WellKnownSymbolsStore, name)) {
	    WellKnownSymbolsStore[name] = symbolConstructorDetection && hasOwnProperty_1(Symbol$1, name) ? Symbol$1[name] : createWellKnownSymbol('Symbol.' + name);
	  }
	  return WellKnownSymbolsStore[name];
	};

	var $TypeError$a = TypeError;
	var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

	// `ToPrimitive` abstract operation
	// https://tc39.es/ecma262/#sec-toprimitive
	var toPrimitive = function (input, pref) {
	  if (!isObject(input) || isSymbol(input)) return input;
	  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
	  var result;
	  if (exoticToPrim) {
	    if (pref === undefined) pref = 'default';
	    result = functionCall(exoticToPrim, input, pref);
	    if (!isObject(result) || isSymbol(result)) return result;
	    throw new $TypeError$a("Can't convert object to primitive value");
	  }
	  if (pref === undefined) pref = 'number';
	  return ordinaryToPrimitive(input, pref);
	};

	// `ToPropertyKey` abstract operation
	// https://tc39.es/ecma262/#sec-topropertykey
	var toPropertyKey = function (argument) {
	  var key = toPrimitive(argument, 'string');
	  return isSymbol(key) ? key : key + '';
	};

	var document$1 = globalThis_1.document;
	// typeof document.createElement is 'object' in old IE
	var EXISTS$1 = isObject(document$1) && isObject(document$1.createElement);
	var documentCreateElement = function (it) {
	  return EXISTS$1 ? document$1.createElement(it) : {};
	};

	// Thanks to IE8 for its funny defineProperty
	var ie8DomDefine = !descriptors && !fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(documentCreateElement('div'), 'a', {
	    get: function () {
	      return 7;
	    }
	  }).a !== 7;
	});

	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;

	// `Object.getOwnPropertyDescriptor` method
	// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
	var f$4 = descriptors ? $getOwnPropertyDescriptor$1 : function getOwnPropertyDescriptor(O, P) {
	  O = toIndexedObject(O);
	  P = toPropertyKey(P);
	  if (ie8DomDefine) try {
	    return $getOwnPropertyDescriptor$1(O, P);
	  } catch (error) {/* empty */}
	  if (hasOwnProperty_1(O, P)) return createPropertyDescriptor(!functionCall(objectPropertyIsEnumerable.f, O, P), O[P]);
	};
	var objectGetOwnPropertyDescriptor = {
	  f: f$4
	};

	// V8 ~ Chrome 36-
	// https://bugs.chromium.org/p/v8/issues/detail?id=3334
	var v8PrototypeDefineBug = descriptors && fails(function () {
	  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
	  return Object.defineProperty(function () {/* empty */}, 'prototype', {
	    value: 42,
	    writable: false
	  }).prototype !== 42;
	});

	var $String$2 = String;
	var $TypeError$9 = TypeError;

	// `Assert: Type(argument) is Object`
	var anObject = function (argument) {
	  if (isObject(argument)) return argument;
	  throw new $TypeError$9($String$2(argument) + ' is not an object');
	};

	var $TypeError$8 = TypeError;
	// eslint-disable-next-line es/no-object-defineproperty -- safe
	var $defineProperty = Object.defineProperty;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var ENUMERABLE = 'enumerable';
	var CONFIGURABLE$1 = 'configurable';
	var WRITABLE = 'writable';

	// `Object.defineProperty` method
	// https://tc39.es/ecma262/#sec-object.defineproperty
	var f$3 = descriptors ? v8PrototypeDefineBug ? function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
	    var current = $getOwnPropertyDescriptor(O, P);
	    if (current && current[WRITABLE]) {
	      O[P] = Attributes.value;
	      Attributes = {
	        configurable: CONFIGURABLE$1 in Attributes ? Attributes[CONFIGURABLE$1] : current[CONFIGURABLE$1],
	        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
	        writable: false
	      };
	    }
	  }
	  return $defineProperty(O, P, Attributes);
	} : $defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPropertyKey(P);
	  anObject(Attributes);
	  if (ie8DomDefine) try {
	    return $defineProperty(O, P, Attributes);
	  } catch (error) {/* empty */}
	  if ('get' in Attributes || 'set' in Attributes) throw new $TypeError$8('Accessors not supported');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};
	var objectDefineProperty = {
	  f: f$3
	};

	var createNonEnumerableProperty = descriptors ? function (object, key, value) {
	  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var FunctionPrototype$1 = Function.prototype;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getDescriptor = descriptors && Object.getOwnPropertyDescriptor;
	var EXISTS = hasOwnProperty_1(FunctionPrototype$1, 'name');
	// additional protection from minified / mangled / dropped function names
	var PROPER = EXISTS && function something() {/* empty */}.name === 'something';
	var CONFIGURABLE = EXISTS && (!descriptors || descriptors && getDescriptor(FunctionPrototype$1, 'name').configurable);
	var functionName = {
	  EXISTS: EXISTS,
	  PROPER: PROPER,
	  CONFIGURABLE: CONFIGURABLE
	};

	var functionToString = functionUncurryThis(Function.toString);

	// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
	if (!isCallable(sharedStore.inspectSource)) {
	  sharedStore.inspectSource = function (it) {
	    return functionToString(it);
	  };
	}
	var inspectSource = sharedStore.inspectSource;

	var WeakMap$1 = globalThis_1.WeakMap;
	var weakMapBasicDetection = isCallable(WeakMap$1) && /native code/.test(String(WeakMap$1));

	var keys = shared('keys');
	var sharedKey = function (key) {
	  return keys[key] || (keys[key] = uid(key));
	};

	var hiddenKeys$1 = {};

	var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
	var TypeError$1 = globalThis_1.TypeError;
	var WeakMap = globalThis_1.WeakMap;
	var set, get, has$1;
	var enforce = function (it) {
	  return has$1(it) ? get(it) : set(it, {});
	};
	var getterFor = function (TYPE) {
	  return function (it) {
	    var state;
	    if (!isObject(it) || (state = get(it)).type !== TYPE) {
	      throw new TypeError$1('Incompatible receiver, ' + TYPE + ' required');
	    }
	    return state;
	  };
	};
	if (weakMapBasicDetection || sharedStore.state) {
	  var store = sharedStore.state || (sharedStore.state = new WeakMap());
	  /* eslint-disable no-self-assign -- prototype methods protection */
	  store.get = store.get;
	  store.has = store.has;
	  store.set = store.set;
	  /* eslint-enable no-self-assign -- prototype methods protection */
	  set = function (it, metadata) {
	    if (store.has(it)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    store.set(it, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return store.get(it) || {};
	  };
	  has$1 = function (it) {
	    return store.has(it);
	  };
	} else {
	  var STATE = sharedKey('state');
	  hiddenKeys$1[STATE] = true;
	  set = function (it, metadata) {
	    if (hasOwnProperty_1(it, STATE)) throw new TypeError$1(OBJECT_ALREADY_INITIALIZED);
	    metadata.facade = it;
	    createNonEnumerableProperty(it, STATE, metadata);
	    return metadata;
	  };
	  get = function (it) {
	    return hasOwnProperty_1(it, STATE) ? it[STATE] : {};
	  };
	  has$1 = function (it) {
	    return hasOwnProperty_1(it, STATE);
	  };
	}
	var internalState = {
	  set: set,
	  get: get,
	  has: has$1,
	  enforce: enforce,
	  getterFor: getterFor
	};

	var makeBuiltIn_1 = createCommonjsModule(function (module) {

	  var CONFIGURABLE_FUNCTION_NAME = functionName.CONFIGURABLE;
	  var enforceInternalState = internalState.enforce;
	  var getInternalState = internalState.get;
	  var $String = String;
	  // eslint-disable-next-line es/no-object-defineproperty -- safe
	  var defineProperty = Object.defineProperty;
	  var stringSlice = functionUncurryThis(''.slice);
	  var replace = functionUncurryThis(''.replace);
	  var join = functionUncurryThis([].join);
	  var CONFIGURABLE_LENGTH = descriptors && !fails(function () {
	    return defineProperty(function () {/* empty */}, 'length', {
	      value: 8
	    }).length !== 8;
	  });
	  var TEMPLATE = String(String).split('String');
	  var makeBuiltIn = module.exports = function (value, name, options) {
	    if (stringSlice($String(name), 0, 7) === 'Symbol(') {
	      name = '[' + replace($String(name), /^Symbol\(([^)]*)\).*$/, '$1') + ']';
	    }
	    if (options && options.getter) name = 'get ' + name;
	    if (options && options.setter) name = 'set ' + name;
	    if (!hasOwnProperty_1(value, 'name') || CONFIGURABLE_FUNCTION_NAME && value.name !== name) {
	      if (descriptors) defineProperty(value, 'name', {
	        value: name,
	        configurable: true
	      });else value.name = name;
	    }
	    if (CONFIGURABLE_LENGTH && options && hasOwnProperty_1(options, 'arity') && value.length !== options.arity) {
	      defineProperty(value, 'length', {
	        value: options.arity
	      });
	    }
	    try {
	      if (options && hasOwnProperty_1(options, 'constructor') && options.constructor) {
	        if (descriptors) defineProperty(value, 'prototype', {
	          writable: false
	        });
	        // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
	      } else if (value.prototype) value.prototype = undefined;
	    } catch (error) {/* empty */}
	    var state = enforceInternalState(value);
	    if (!hasOwnProperty_1(state, 'source')) {
	      state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
	    }
	    return value;
	  };

	  // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	  // eslint-disable-next-line no-extend-native -- required
	  Function.prototype.toString = makeBuiltIn(function toString() {
	    return isCallable(this) && getInternalState(this).source || inspectSource(this);
	  }, 'toString');
	});

	var defineBuiltIn = function (O, key, value, options) {
	  if (!options) options = {};
	  var simple = options.enumerable;
	  var name = options.name !== undefined ? options.name : key;
	  if (isCallable(value)) makeBuiltIn_1(value, name, options);
	  if (options.global) {
	    if (simple) O[key] = value;else defineGlobalProperty(key, value);
	  } else {
	    try {
	      if (!options.unsafe) delete O[key];else if (O[key]) simple = true;
	    } catch (error) {/* empty */}
	    if (simple) O[key] = value;else objectDefineProperty.f(O, key, {
	      value: value,
	      enumerable: false,
	      configurable: !options.nonConfigurable,
	      writable: !options.nonWritable
	    });
	  }
	  return O;
	};

	var ceil = Math.ceil;
	var floor = Math.floor;

	// `Math.trunc` method
	// https://tc39.es/ecma262/#sec-math.trunc
	// eslint-disable-next-line es/no-math-trunc -- safe
	var mathTrunc = Math.trunc || function trunc(x) {
	  var n = +x;
	  return (n > 0 ? floor : ceil)(n);
	};

	// `ToIntegerOrInfinity` abstract operation
	// https://tc39.es/ecma262/#sec-tointegerorinfinity
	var toIntegerOrInfinity = function (argument) {
	  var number = +argument;
	  // eslint-disable-next-line no-self-compare -- NaN check
	  return number !== number || number === 0 ? 0 : mathTrunc(number);
	};

	var max = Math.max;
	var min$1 = Math.min;

	// Helper for a popular repeating case of the spec:
	// Let integer be ? ToInteger(index).
	// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
	var toAbsoluteIndex = function (index, length) {
	  var integer = toIntegerOrInfinity(index);
	  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
	};

	var min = Math.min;

	// `ToLength` abstract operation
	// https://tc39.es/ecma262/#sec-tolength
	var toLength = function (argument) {
	  var len = toIntegerOrInfinity(argument);
	  return len > 0 ? min(len, 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
	};

	// `LengthOfArrayLike` abstract operation
	// https://tc39.es/ecma262/#sec-lengthofarraylike
	var lengthOfArrayLike = function (obj) {
	  return toLength(obj.length);
	};

	// `Array.prototype.{ indexOf, includes }` methods implementation
	var createMethod = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIndexedObject($this);
	    var length = lengthOfArrayLike(O);
	    if (length === 0) return !IS_INCLUDES && -1;
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare -- NaN check
	    if (IS_INCLUDES && el !== el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare -- NaN check
	      if (value !== value) return true;
	      // Array#indexOf ignores holes, Array#includes - not
	    } else for (; length > index; index++) {
	      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
	    }
	    return !IS_INCLUDES && -1;
	  };
	};
	var arrayIncludes = {
	  // `Array.prototype.includes` method
	  // https://tc39.es/ecma262/#sec-array.prototype.includes
	  includes: createMethod(true),
	  // `Array.prototype.indexOf` method
	  // https://tc39.es/ecma262/#sec-array.prototype.indexof
	  indexOf: createMethod(false)
	};

	var indexOf = arrayIncludes.indexOf;
	var push$3 = functionUncurryThis([].push);
	var objectKeysInternal = function (object, names) {
	  var O = toIndexedObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) !hasOwnProperty_1(hiddenKeys$1, key) && hasOwnProperty_1(O, key) && push$3(result, key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (hasOwnProperty_1(O, key = names[i++])) {
	    ~indexOf(result, key) || push$3(result, key);
	  }
	  return result;
	};

	// IE8- don't enum bug keys
	var enumBugKeys = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf'];

	var hiddenKeys = enumBugKeys.concat('length', 'prototype');

	// `Object.getOwnPropertyNames` method
	// https://tc39.es/ecma262/#sec-object.getownpropertynames
	// eslint-disable-next-line es/no-object-getownpropertynames -- safe
	var f$2 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return objectKeysInternal(O, hiddenKeys);
	};
	var objectGetOwnPropertyNames = {
	  f: f$2
	};

	// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
	var f$1 = Object.getOwnPropertySymbols;
	var objectGetOwnPropertySymbols = {
	  f: f$1
	};

	var concat = functionUncurryThis([].concat);

	// all object keys, includes non-enumerable and symbols
	var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
	  var keys = objectGetOwnPropertyNames.f(anObject(it));
	  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
	  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
	};

	var copyConstructorProperties = function (target, source, exceptions) {
	  var keys = ownKeys(source);
	  var defineProperty = objectDefineProperty.f;
	  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    if (!hasOwnProperty_1(target, key) && !(exceptions && hasOwnProperty_1(exceptions, key))) {
	      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
	    }
	  }
	};

	var replacement = /#|\.prototype\./;
	var isForced = function (feature, detection) {
	  var value = data[normalize(feature)];
	  return value === POLYFILL ? true : value === NATIVE ? false : isCallable(detection) ? fails(detection) : !!detection;
	};
	var normalize = isForced.normalize = function (string) {
	  return String(string).replace(replacement, '.').toLowerCase();
	};
	var data = isForced.data = {};
	var NATIVE = isForced.NATIVE = 'N';
	var POLYFILL = isForced.POLYFILL = 'P';
	var isForced_1 = isForced;

	var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;

	/*
	  options.target         - name of the target object
	  options.global         - target is the global object
	  options.stat           - export as static methods of target
	  options.proto          - export as prototype methods of target
	  options.real           - real prototype method for the `pure` version
	  options.forced         - export even if the native feature is available
	  options.bind           - bind methods to the target, required for the `pure` version
	  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
	  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
	  options.sham           - add a flag to not completely full polyfills
	  options.enumerable     - export as enumerable property
	  options.dontCallGetSet - prevent calling a getter on target
	  options.name           - the .name of the function if it does not match the key
	*/
	var _export = function (options, source) {
	  var TARGET = options.target;
	  var GLOBAL = options.global;
	  var STATIC = options.stat;
	  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
	  if (GLOBAL) {
	    target = globalThis_1;
	  } else if (STATIC) {
	    target = globalThis_1[TARGET] || defineGlobalProperty(TARGET, {});
	  } else {
	    target = globalThis_1[TARGET] && globalThis_1[TARGET].prototype;
	  }
	  if (target) for (key in source) {
	    sourceProperty = source[key];
	    if (options.dontCallGetSet) {
	      descriptor = getOwnPropertyDescriptor$2(target, key);
	      targetProperty = descriptor && descriptor.value;
	    } else targetProperty = target[key];
	    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
	    // contained in target
	    if (!FORCED && targetProperty !== undefined) {
	      if (typeof sourceProperty == typeof targetProperty) continue;
	      copyConstructorProperties(sourceProperty, targetProperty);
	    }
	    // add a flag to not completely full polyfills
	    if (options.sham || targetProperty && targetProperty.sham) {
	      createNonEnumerableProperty(sourceProperty, 'sham', true);
	    }
	    defineBuiltIn(target, key, sourceProperty, options);
	  }
	};

	var $TypeError$7 = TypeError;
	var anInstance = function (it, Prototype) {
	  if (objectIsPrototypeOf(Prototype, it)) return it;
	  throw new $TypeError$7('Incorrect invocation');
	};

	var correctPrototypeGetter = !fails(function () {
	  function F() {/* empty */}
	  F.prototype.constructor = null;
	  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
	  return Object.getPrototypeOf(new F()) !== F.prototype;
	});

	var IE_PROTO$1 = sharedKey('IE_PROTO');
	var $Object$1 = Object;
	var ObjectPrototype = $Object$1.prototype;

	// `Object.getPrototypeOf` method
	// https://tc39.es/ecma262/#sec-object.getprototypeof
	// eslint-disable-next-line es/no-object-getprototypeof -- safe
	var objectGetPrototypeOf = correctPrototypeGetter ? $Object$1.getPrototypeOf : function (O) {
	  var object = toObject(O);
	  if (hasOwnProperty_1(object, IE_PROTO$1)) return object[IE_PROTO$1];
	  var constructor = object.constructor;
	  if (isCallable(constructor) && object instanceof constructor) {
	    return constructor.prototype;
	  }
	  return object instanceof $Object$1 ? ObjectPrototype : null;
	};

	var defineBuiltInAccessor = function (target, name, descriptor) {
	  if (descriptor.get) makeBuiltIn_1(descriptor.get, name, {
	    getter: true
	  });
	  if (descriptor.set) makeBuiltIn_1(descriptor.set, name, {
	    setter: true
	  });
	  return objectDefineProperty.f(target, name, descriptor);
	};

	var createProperty = function (object, key, value) {
	  if (descriptors) objectDefineProperty.f(object, key, createPropertyDescriptor(0, value));else object[key] = value;
	};

	// `Object.keys` method
	// https://tc39.es/ecma262/#sec-object.keys
	// eslint-disable-next-line es/no-object-keys -- safe
	var objectKeys = Object.keys || function keys(O) {
	  return objectKeysInternal(O, enumBugKeys);
	};

	// `Object.defineProperties` method
	// https://tc39.es/ecma262/#sec-object.defineproperties
	// eslint-disable-next-line es/no-object-defineproperties -- safe
	var f = descriptors && !v8PrototypeDefineBug ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var props = toIndexedObject(Properties);
	  var keys = objectKeys(Properties);
	  var length = keys.length;
	  var index = 0;
	  var key;
	  while (length > index) objectDefineProperty.f(O, key = keys[index++], props[key]);
	  return O;
	};
	var objectDefineProperties = {
	  f: f
	};

	var html = getBuiltIn('document', 'documentElement');

	/* global ActiveXObject -- old IE, WSH */

	var GT = '>';
	var LT = '<';
	var PROTOTYPE = 'prototype';
	var SCRIPT = 'script';
	var IE_PROTO = sharedKey('IE_PROTO');
	var EmptyConstructor = function () {/* empty */};
	var scriptTag = function (content) {
	  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
	};

	// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
	var NullProtoObjectViaActiveX = function (activeXDocument) {
	  activeXDocument.write(scriptTag(''));
	  activeXDocument.close();
	  var temp = activeXDocument.parentWindow.Object;
	  // eslint-disable-next-line no-useless-assignment -- avoid memory leak
	  activeXDocument = null;
	  return temp;
	};

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var NullProtoObjectViaIFrame = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = documentCreateElement('iframe');
	  var JS = 'java' + SCRIPT + ':';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  html.appendChild(iframe);
	  // https://github.com/zloirock/core-js/issues/475
	  iframe.src = String(JS);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(scriptTag('document.F=Object'));
	  iframeDocument.close();
	  return iframeDocument.F;
	};

	// Check for document.domain and active x support
	// No need to use active x approach when document.domain is not set
	// see https://github.com/es-shims/es5-shim/issues/150
	// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
	// avoid IE GC bug
	var activeXDocument;
	var NullProtoObject = function () {
	  try {
	    activeXDocument = new ActiveXObject('htmlfile');
	  } catch (error) {/* ignore */}
	  NullProtoObject = typeof document != 'undefined' ? document.domain && activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) // old IE
	  : NullProtoObjectViaIFrame() : NullProtoObjectViaActiveX(activeXDocument); // WSH
	  var length = enumBugKeys.length;
	  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
	  return NullProtoObject();
	};
	hiddenKeys$1[IE_PROTO] = true;

	// `Object.create` method
	// https://tc39.es/ecma262/#sec-object.create
	// eslint-disable-next-line es/no-object-create -- safe
	var objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    EmptyConstructor[PROTOTYPE] = anObject(O);
	    result = new EmptyConstructor();
	    EmptyConstructor[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = NullProtoObject();
	  return Properties === undefined ? result : objectDefineProperties.f(result, Properties);
	};

	var ITERATOR$3 = wellKnownSymbol('iterator');
	var BUGGY_SAFARI_ITERATORS = false;

	// `%IteratorPrototype%` object
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
	var IteratorPrototype$2, PrototypeOfArrayIteratorPrototype, arrayIterator;

	/* eslint-disable es/no-array-prototype-keys -- safe */
	if ([].keys) {
	  arrayIterator = [].keys();
	  // Safari 8 has buggy iterators w/o `next`
	  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;else {
	    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
	    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype$2 = PrototypeOfArrayIteratorPrototype;
	  }
	}
	var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype$2) || fails(function () {
	  var test = {};
	  // FF44- legacy iterators case
	  return IteratorPrototype$2[ITERATOR$3].call(test) !== test;
	});
	if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype$2 = {};

	// `%IteratorPrototype%[@@iterator]()` method
	// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
	if (!isCallable(IteratorPrototype$2[ITERATOR$3])) {
	  defineBuiltIn(IteratorPrototype$2, ITERATOR$3, function () {
	    return this;
	  });
	}
	var iteratorsCore = {
	  IteratorPrototype: IteratorPrototype$2,
	  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
	};

	var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;
	var CONSTRUCTOR = 'constructor';
	var ITERATOR$2 = 'Iterator';
	var TO_STRING_TAG$3 = wellKnownSymbol('toStringTag');
	var $TypeError$6 = TypeError;
	var NativeIterator = globalThis_1[ITERATOR$2];

	// FF56- have non-standard global helper `Iterator`
	var FORCED$3 = !isCallable(NativeIterator) || NativeIterator.prototype !== IteratorPrototype$1
	// FF44- non-standard `Iterator` passes previous tests
	|| !fails(function () {
	  NativeIterator({});
	});
	var IteratorConstructor = function Iterator() {
	  anInstance(this, IteratorPrototype$1);
	  if (objectGetPrototypeOf(this) === IteratorPrototype$1) throw new $TypeError$6('Abstract class Iterator not directly constructable');
	};
	var defineIteratorPrototypeAccessor = function (key, value) {
	  if (descriptors) {
	    defineBuiltInAccessor(IteratorPrototype$1, key, {
	      configurable: true,
	      get: function () {
	        return value;
	      },
	      set: function (replacement) {
	        anObject(this);
	        if (this === IteratorPrototype$1) throw new $TypeError$6("You can't redefine this property");
	        if (hasOwnProperty_1(this, key)) this[key] = replacement;else createProperty(this, key, replacement);
	      }
	    });
	  } else IteratorPrototype$1[key] = value;
	};
	if (!hasOwnProperty_1(IteratorPrototype$1, TO_STRING_TAG$3)) defineIteratorPrototypeAccessor(TO_STRING_TAG$3, ITERATOR$2);
	if (FORCED$3 || !hasOwnProperty_1(IteratorPrototype$1, CONSTRUCTOR) || IteratorPrototype$1[CONSTRUCTOR] === Object) {
	  defineIteratorPrototypeAccessor(CONSTRUCTOR, IteratorConstructor);
	}
	IteratorConstructor.prototype = IteratorPrototype$1;

	// `Iterator` constructor
	// https://tc39.es/ecma262/#sec-iterator
	_export({
	  global: true,
	  constructor: true,
	  forced: FORCED$3
	}, {
	  Iterator: IteratorConstructor
	});

	var functionUncurryThisClause = function (fn) {
	  // Nashorn bug:
	  //   https://github.com/zloirock/core-js/issues/1128
	  //   https://github.com/zloirock/core-js/issues/1130
	  if (classofRaw(fn) === 'Function') return functionUncurryThis(fn);
	};

	var bind = functionUncurryThisClause(functionUncurryThisClause.bind);

	// optional / simple context binding
	var functionBindContext = function (fn, that) {
	  aCallable(fn);
	  return that === undefined ? fn : functionBindNative ? bind(fn, that) : function /* ...args */
	  () {
	    return fn.apply(that, arguments);
	  };
	};

	var iterators = {};

	var ITERATOR$1 = wellKnownSymbol('iterator');
	var ArrayPrototype$1 = Array.prototype;

	// check on default Array iterator
	var isArrayIteratorMethod = function (it) {
	  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR$1] === it);
	};

	var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');
	var test = {};
	// eslint-disable-next-line unicorn/no-immediate-mutation -- ES3 syntax limitation
	test[TO_STRING_TAG$2] = 'z';
	var toStringTagSupport = String(test) === '[object z]';

	var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
	var $Object = Object;

	// ES3 wrong here
	var CORRECT_ARGUMENTS = classofRaw(function () {
	  return arguments;
	}()) === 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (error) {/* empty */}
	};

	// getting tag from ES6+ `Object.prototype.toString`
	var classof = toStringTagSupport ? classofRaw : function (it) {
	  var O, tag, result;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	  // @@toStringTag case
	  : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG$1)) == 'string' ? tag
	  // builtinTag case
	  : CORRECT_ARGUMENTS ? classofRaw(O)
	  // ES3 arguments fallback
	  : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
	};

	var ITERATOR = wellKnownSymbol('iterator');
	var getIteratorMethod = function (it) {
	  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR) || getMethod(it, '@@iterator') || iterators[classof(it)];
	};

	var $TypeError$5 = TypeError;
	var getIterator = function (argument, usingIterator) {
	  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
	  if (aCallable(iteratorMethod)) return anObject(functionCall(iteratorMethod, argument));
	  throw new $TypeError$5(tryToString(argument) + ' is not iterable');
	};

	var iteratorClose = function (iterator, kind, value) {
	  var innerResult, innerError;
	  anObject(iterator);
	  try {
	    innerResult = getMethod(iterator, 'return');
	    if (!innerResult) {
	      if (kind === 'throw') throw value;
	      return value;
	    }
	    innerResult = functionCall(innerResult, iterator);
	  } catch (error) {
	    innerError = true;
	    innerResult = error;
	  }
	  if (kind === 'throw') throw value;
	  if (innerError) throw innerResult;
	  anObject(innerResult);
	  return value;
	};

	var $TypeError$4 = TypeError;
	var Result = function (stopped, result) {
	  this.stopped = stopped;
	  this.result = result;
	};
	var ResultPrototype = Result.prototype;
	var iterate = function (iterable, unboundFunction, options) {
	  var that = options && options.that;
	  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
	  var IS_RECORD = !!(options && options.IS_RECORD);
	  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
	  var INTERRUPTED = !!(options && options.INTERRUPTED);
	  var fn = functionBindContext(unboundFunction, that);
	  var iterator, iterFn, index, length, result, next, step;
	  var stop = function (condition) {
	    var $iterator = iterator;
	    iterator = undefined;
	    if ($iterator) iteratorClose($iterator, 'normal');
	    return new Result(true, condition);
	  };
	  var callFn = function (value) {
	    if (AS_ENTRIES) {
	      anObject(value);
	      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
	    }
	    return INTERRUPTED ? fn(value, stop) : fn(value);
	  };
	  if (IS_RECORD) {
	    iterator = iterable.iterator;
	  } else if (IS_ITERATOR) {
	    iterator = iterable;
	  } else {
	    iterFn = getIteratorMethod(iterable);
	    if (!iterFn) throw new $TypeError$4(tryToString(iterable) + ' is not iterable');
	    // optimisation for array iterators
	    if (isArrayIteratorMethod(iterFn)) {
	      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
	        result = callFn(iterable[index]);
	        if (result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	      }
	      return new Result(false);
	    }
	    iterator = getIterator(iterable, iterFn);
	  }
	  next = IS_RECORD ? iterable.next : iterator.next;
	  while (!(step = functionCall(next, iterator)).done) {
	    // `IteratorValue` errors should propagate without closing the iterator
	    var value = step.value;
	    try {
	      result = callFn(value);
	    } catch (error) {
	      if (iterator) iteratorClose(iterator, 'throw', error);else throw error;
	    }
	    if (typeof result == 'object' && result && objectIsPrototypeOf(ResultPrototype, result)) return result;
	  }
	  return new Result(false);
	};

	// `GetIteratorDirect(obj)` abstract operation
	// https://tc39.es/ecma262/#sec-getiteratordirect
	var getIteratorDirect = function (obj) {
	  return {
	    iterator: obj,
	    next: obj.next,
	    done: false
	  };
	};

	// https://github.com/tc39/ecma262/pull/3467
	var iteratorHelperWithoutClosingOnEarlyError = function (METHOD_NAME, ExpectedError) {
	  var Iterator = globalThis_1.Iterator;
	  var IteratorPrototype = Iterator && Iterator.prototype;
	  var method = IteratorPrototype && IteratorPrototype[METHOD_NAME];
	  var CLOSED = false;
	  if (method) try {
	    method.call({
	      next: function () {
	        return {
	          done: true
	        };
	      },
	      'return': function () {
	        CLOSED = true;
	      }
	    }, -1);
	  } catch (error) {
	    // https://bugs.webkit.org/show_bug.cgi?id=291195
	    if (!(error instanceof ExpectedError)) CLOSED = false;
	  }
	  if (!CLOSED) return method;
	};

	var findWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('find', TypeError);

	// `Iterator.prototype.find` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.find
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: findWithoutClosingOnEarlyError
	}, {
	  find: function find(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (findWithoutClosingOnEarlyError) return functionCall(findWithoutClosingOnEarlyError, this, predicate);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    return iterate(record, function (value, stop) {
	      if (predicate(value, counter++)) return stop(value);
	    }, {
	      IS_RECORD: true,
	      INTERRUPTED: true
	    }).result;
	  }
	});

	var forEachWithoutClosingOnEarlyError = iteratorHelperWithoutClosingOnEarlyError('forEach', TypeError);

	// `Iterator.prototype.forEach` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.foreach
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: forEachWithoutClosingOnEarlyError
	}, {
	  forEach: function forEach(fn) {
	    anObject(this);
	    try {
	      aCallable(fn);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (forEachWithoutClosingOnEarlyError) return functionCall(forEachWithoutClosingOnEarlyError, this, fn);
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    iterate(record, function (value) {
	      fn(value, counter++);
	    }, {
	      IS_RECORD: true
	    });
	  }
	});

	// `IsArray` abstract operation
	// https://tc39.es/ecma262/#sec-isarray
	// eslint-disable-next-line es/no-array-isarray -- safe
	var isArray = Array.isArray || function isArray(argument) {
	  return classofRaw(argument) === 'Array';
	};

	var $String$1 = String;
	var toString_1 = function (argument) {
	  if (classof(argument) === 'Symbol') throw new TypeError('Cannot convert a Symbol value to a string');
	  return $String$1(argument);
	};

	var $SyntaxError = SyntaxError;
	var $parseInt = parseInt;
	var fromCharCode = String.fromCharCode;
	var at$1 = functionUncurryThis(''.charAt);
	var slice$2 = functionUncurryThis(''.slice);
	var exec$2 = functionUncurryThis(/./.exec);
	var codePoints = {
	  '\\"': '"',
	  '\\\\': '\\',
	  '\\/': '/',
	  '\\b': '\b',
	  '\\f': '\f',
	  '\\n': '\n',
	  '\\r': '\r',
	  '\\t': '\t'
	};
	var IS_4_HEX_DIGITS = /^[\da-f]{4}$/i;
	// eslint-disable-next-line regexp/no-control-character -- safe
	var IS_C0_CONTROL_CODE = /^[\u0000-\u001F]$/;
	var parseJsonString = function (source, i) {
	  var unterminated = true;
	  var value = '';
	  while (i < source.length) {
	    var chr = at$1(source, i);
	    if (chr === '\\') {
	      var twoChars = slice$2(source, i, i + 2);
	      if (hasOwnProperty_1(codePoints, twoChars)) {
	        value += codePoints[twoChars];
	        i += 2;
	      } else if (twoChars === '\\u') {
	        i += 2;
	        var fourHexDigits = slice$2(source, i, i + 4);
	        if (!exec$2(IS_4_HEX_DIGITS, fourHexDigits)) throw new $SyntaxError('Bad Unicode escape at: ' + i);
	        value += fromCharCode($parseInt(fourHexDigits, 16));
	        i += 4;
	      } else throw new $SyntaxError('Unknown escape sequence: "' + twoChars + '"');
	    } else if (chr === '"') {
	      unterminated = false;
	      i++;
	      break;
	    } else {
	      if (exec$2(IS_C0_CONTROL_CODE, chr)) throw new $SyntaxError('Bad control character in string literal at: ' + i);
	      value += chr;
	      i++;
	    }
	  }
	  if (unterminated) throw new $SyntaxError('Unterminated string at: ' + i);
	  return {
	    value: value,
	    end: i
	  };
	};

	var JSON$1 = globalThis_1.JSON;
	var Number$1 = globalThis_1.Number;
	var SyntaxError$1 = globalThis_1.SyntaxError;
	var nativeParse = JSON$1 && JSON$1.parse;
	var enumerableOwnProperties = getBuiltIn('Object', 'keys');
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor$1 = Object.getOwnPropertyDescriptor;
	var at = functionUncurryThis(''.charAt);
	var slice$1 = functionUncurryThis(''.slice);
	var exec$1 = functionUncurryThis(/./.exec);
	var push$2 = functionUncurryThis([].push);
	var IS_DIGIT = /^\d$/;
	var IS_NON_ZERO_DIGIT = /^[1-9]$/;
	var IS_NUMBER_START = /^[\d-]$/;
	var IS_WHITESPACE = /^[\t\n\r ]$/;
	var PRIMITIVE = 0;
	var OBJECT = 1;
	var $parse = function (source, reviver) {
	  source = toString_1(source);
	  var context = new Context(source, 0);
	  var root = context.parse();
	  var value = root.value;
	  var endIndex = context.skip(IS_WHITESPACE, root.end);
	  if (endIndex < source.length) {
	    throw new SyntaxError$1('Unexpected extra character: "' + at(source, endIndex) + '" after the parsed data at: ' + endIndex);
	  }
	  return isCallable(reviver) ? internalize({
	    '': value
	  }, '', reviver, root) : value;
	};
	var internalize = function (holder, name, reviver, node) {
	  var val = holder[name];
	  var unmodified = node && val === node.value;
	  var context = unmodified && typeof node.source == 'string' ? {
	    source: node.source
	  } : {};
	  var elementRecordsLen, keys, len, i, P;
	  if (isObject(val)) {
	    var nodeIsArray = isArray(val);
	    var nodes = unmodified ? node.nodes : nodeIsArray ? [] : {};
	    if (nodeIsArray) {
	      elementRecordsLen = nodes.length;
	      len = lengthOfArrayLike(val);
	      for (i = 0; i < len; i++) {
	        internalizeProperty(val, i, internalize(val, '' + i, reviver, i < elementRecordsLen ? nodes[i] : undefined));
	      }
	    } else {
	      keys = enumerableOwnProperties(val);
	      len = lengthOfArrayLike(keys);
	      for (i = 0; i < len; i++) {
	        P = keys[i];
	        internalizeProperty(val, P, internalize(val, P, reviver, hasOwnProperty_1(nodes, P) ? nodes[P] : undefined));
	      }
	    }
	  }
	  return functionCall(reviver, holder, name, val, context);
	};
	var internalizeProperty = function (object, key, value) {
	  if (descriptors) {
	    var descriptor = getOwnPropertyDescriptor$1(object, key);
	    if (descriptor && !descriptor.configurable) return;
	  }
	  if (value === undefined) delete object[key];else createProperty(object, key, value);
	};
	var Node = function (value, end, source, nodes) {
	  this.value = value;
	  this.end = end;
	  this.source = source;
	  this.nodes = nodes;
	};
	var Context = function (source, index) {
	  this.source = source;
	  this.index = index;
	};

	// https://www.json.org/json-en.html
	Context.prototype = {
	  fork: function (nextIndex) {
	    return new Context(this.source, nextIndex);
	  },
	  parse: function () {
	    var source = this.source;
	    var i = this.skip(IS_WHITESPACE, this.index);
	    var fork = this.fork(i);
	    var chr = at(source, i);
	    if (exec$1(IS_NUMBER_START, chr)) return fork.number();
	    switch (chr) {
	      case '{':
	        return fork.object();
	      case '[':
	        return fork.array();
	      case '"':
	        return fork.string();
	      case 't':
	        return fork.keyword(true);
	      case 'f':
	        return fork.keyword(false);
	      case 'n':
	        return fork.keyword(null);
	    }
	    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
	  },
	  node: function (type, value, start, end, nodes) {
	    return new Node(value, end, type ? null : slice$1(this.source, start, end), nodes);
	  },
	  object: function () {
	    var source = this.source;
	    var i = this.index + 1;
	    var expectKeypair = false;
	    var object = {};
	    var nodes = {};
	    var closed = false;
	    while (i < source.length) {
	      i = this.until(['"', '}'], i);
	      if (at(source, i) === '}' && !expectKeypair) {
	        i++;
	        closed = true;
	        break;
	      }
	      // Parsing the key
	      var result = this.fork(i).string();
	      var key = result.value;
	      i = result.end;
	      i = this.until([':'], i) + 1;
	      // Parsing value
	      i = this.skip(IS_WHITESPACE, i);
	      result = this.fork(i).parse();
	      createProperty(nodes, key, result);
	      createProperty(object, key, result.value);
	      i = this.until([',', '}'], result.end);
	      var chr = at(source, i);
	      if (chr === ',') {
	        expectKeypair = true;
	        i++;
	      } else if (chr === '}') {
	        i++;
	        closed = true;
	        break;
	      }
	    }
	    if (!closed) throw new SyntaxError$1('Unterminated object at: ' + i);
	    return this.node(OBJECT, object, this.index, i, nodes);
	  },
	  array: function () {
	    var source = this.source;
	    var i = this.index + 1;
	    var expectElement = false;
	    var array = [];
	    var nodes = [];
	    var closed = false;
	    while (i < source.length) {
	      i = this.skip(IS_WHITESPACE, i);
	      if (at(source, i) === ']' && !expectElement) {
	        i++;
	        closed = true;
	        break;
	      }
	      var result = this.fork(i).parse();
	      push$2(nodes, result);
	      push$2(array, result.value);
	      i = this.until([',', ']'], result.end);
	      if (at(source, i) === ',') {
	        expectElement = true;
	        i++;
	      } else if (at(source, i) === ']') {
	        i++;
	        closed = true;
	        break;
	      }
	    }
	    if (!closed) throw new SyntaxError$1('Unterminated array at: ' + i);
	    return this.node(OBJECT, array, this.index, i, nodes);
	  },
	  string: function () {
	    var index = this.index;
	    var parsed = parseJsonString(this.source, this.index + 1);
	    return this.node(PRIMITIVE, parsed.value, index, parsed.end);
	  },
	  number: function () {
	    var source = this.source;
	    var startIndex = this.index;
	    var i = startIndex;
	    if (at(source, i) === '-') i++;
	    if (at(source, i) === '0') i++;else if (exec$1(IS_NON_ZERO_DIGIT, at(source, i))) i = this.skip(IS_DIGIT, i + 1);else throw new SyntaxError$1('Failed to parse number at: ' + i);
	    if (at(source, i) === '.') {
	      var fractionStartIndex = i + 1;
	      i = this.skip(IS_DIGIT, fractionStartIndex);
	      if (fractionStartIndex === i) throw new SyntaxError$1("Failed to parse number's fraction at: " + i);
	    }
	    if (at(source, i) === 'e' || at(source, i) === 'E') {
	      i++;
	      if (at(source, i) === '+' || at(source, i) === '-') i++;
	      var exponentStartIndex = i;
	      i = this.skip(IS_DIGIT, i);
	      if (exponentStartIndex === i) throw new SyntaxError$1("Failed to parse number's exponent value at: " + i);
	    }
	    return this.node(PRIMITIVE, Number$1(slice$1(source, startIndex, i)), startIndex, i);
	  },
	  keyword: function (value) {
	    var keyword = '' + value;
	    var index = this.index;
	    var endIndex = index + keyword.length;
	    if (slice$1(this.source, index, endIndex) !== keyword) throw new SyntaxError$1('Failed to parse value at: ' + index);
	    return this.node(PRIMITIVE, value, index, endIndex);
	  },
	  skip: function (regex, i) {
	    var source = this.source;
	    for (; i < source.length; i++) if (!exec$1(regex, at(source, i))) break;
	    return i;
	  },
	  until: function (array, i) {
	    i = this.skip(IS_WHITESPACE, i);
	    var chr = at(this.source, i);
	    for (var j = 0; j < array.length; j++) if (array[j] === chr) return i;
	    throw new SyntaxError$1('Unexpected character: "' + chr + '" at: ' + i);
	  }
	};
	var NO_SOURCE_SUPPORT = fails(function () {
	  var unsafeInt = '9007199254740993';
	  var source;
	  nativeParse(unsafeInt, function (key, value, context) {
	    source = context.source;
	  });
	  return source !== unsafeInt;
	});
	var PROPER_BASE_PARSE = symbolConstructorDetection && !fails(function () {
	  // Safari 9 bug
	  return 1 / nativeParse('-0 \t') !== -Infinity;
	});

	// `JSON.parse` method
	// https://tc39.es/ecma262/#sec-json.parse
	// https://github.com/tc39/proposal-json-parse-with-source
	_export({
	  target: 'JSON',
	  stat: true,
	  forced: NO_SOURCE_SUPPORT
	}, {
	  parse: function parse(text, reviver) {
	    return PROPER_BASE_PARSE && !isCallable(reviver) ? nativeParse(text) : $parse(text, reviver);
	  }
	});

	Math.log10 = Math.log10 || function (x) {
	  return Math.log(x) * Math.LOG10E;
	};

	var defineProperty = objectDefineProperty.f;
	var UNSCOPABLES = wellKnownSymbol('unscopables');
	var ArrayPrototype = Array.prototype;

	// Array.prototype[@@unscopables]
	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	if (ArrayPrototype[UNSCOPABLES] === undefined) {
	  defineProperty(ArrayPrototype, UNSCOPABLES, {
	    configurable: true,
	    value: objectCreate(null)
	  });
	}

	// add a key to Array.prototype[@@unscopables]
	var addToUnscopables = function (key) {
	  ArrayPrototype[UNSCOPABLES][key] = true;
	};

	var $includes = arrayIncludes.includes;

	// FF99+ bug
	var BROKEN_ON_SPARSE = fails(function () {
	  // eslint-disable-next-line es/no-array-prototype-includes -- detection
	  return !Array(1).includes();
	});

	// Safari 26.4- bug
	var BROKEN_ON_SPARSE_WITH_FROM_INDEX = fails(function () {
	  // eslint-disable-next-line no-sparse-arrays, es/no-array-prototype-includes -- detection
	  return [, 1].includes(undefined, 1);
	});

	// `Array.prototype.includes` method
	// https://tc39.es/ecma262/#sec-array.prototype.includes
	_export({
	  target: 'Array',
	  proto: true,
	  forced: BROKEN_ON_SPARSE || BROKEN_ON_SPARSE_WITH_FROM_INDEX
	}, {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});

	// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
	addToUnscopables('includes');

	var $TypeError$3 = TypeError;
	// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

	// Safari < 13 does not throw an error in this case
	var SILENT_ON_NON_WRITABLE_LENGTH_SET = descriptors && !function () {
	  // makes no sense without proper strict mode support
	  if (this !== undefined) return true;
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).length = 1;
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	}();
	var arraySetLength = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
	  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
	    throw new $TypeError$3('Cannot set read only .length');
	  }
	  return O.length = length;
	} : function (O, length) {
	  return O.length = length;
	};

	var $TypeError$2 = TypeError;
	var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

	var doesNotExceedSafeInteger = function (it) {
	  if (it > MAX_SAFE_INTEGER) throw new $TypeError$2('Maximum allowed index exceeded');
	  return it;
	};

	var INCORRECT_TO_LENGTH = fails(function () {
	  return [].push.call({
	    length: 0x100000000
	  }, 1) !== 4294967297;
	});

	// V8 <= 121 and Safari <= 15.4; FF < 23 throws InternalError
	// https://bugs.chromium.org/p/v8/issues/detail?id=12681
	var properErrorOnNonWritableLength = function () {
	  try {
	    // eslint-disable-next-line es/no-object-defineproperty -- safe
	    Object.defineProperty([], 'length', {
	      writable: false
	    }).push();
	  } catch (error) {
	    return error instanceof TypeError;
	  }
	};
	var FORCED$2 = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

	// `Array.prototype.push` method
	// https://tc39.es/ecma262/#sec-array.prototype.push
	_export({
	  target: 'Array',
	  proto: true,
	  arity: 1,
	  forced: FORCED$2
	}, {
	  // eslint-disable-next-line no-unused-vars -- required for `.length`
	  push: function push(item) {
	    var O = toObject(this);
	    var len = lengthOfArrayLike(O);
	    var argCount = arguments.length;
	    doesNotExceedSafeInteger(len + argCount);
	    for (var i = 0; i < argCount; i++) {
	      O[len] = arguments[i];
	      len++;
	    }
	    arraySetLength(O, len);
	    return len;
	  }
	});

	var FunctionPrototype = Function.prototype;
	var apply = FunctionPrototype.apply;
	var call = FunctionPrototype.call;

	// eslint-disable-next-line es/no-function-prototype-bind, es/no-reflect -- safe
	var functionApply = typeof Reflect == 'object' && Reflect.apply || (functionBindNative ? call.bind(apply) : function () {
	  return call.apply(apply, arguments);
	});

	var getInternalState = internalState.get;
	var isRawJson = function isRawJSON(O) {
	  if (!isObject(O)) return false;
	  var state = getInternalState(O);
	  return !!state && state.type === 'RawJSON';
	};

	var arraySlice = functionUncurryThis([].slice);

	/* eslint-disable es/no-json -- safe */

	var nativeRawJson = !fails(function () {
	  var unsafeInt = '9007199254740993';
	  // eslint-disable-next-line es/no-json-rawjson -- feature detection
	  var raw = JSON.rawJSON(unsafeInt);
	  // eslint-disable-next-line es/no-json-israwjson -- feature detection
	  return !JSON.isRawJSON(raw) || JSON.stringify(raw) !== unsafeInt;
	});

	var $String = String;
	var $stringify = getBuiltIn('JSON', 'stringify');
	var exec = functionUncurryThis(/./.exec);
	var charAt = functionUncurryThis(''.charAt);
	var charCodeAt = functionUncurryThis(''.charCodeAt);
	var replace = functionUncurryThis(''.replace);
	var slice = functionUncurryThis(''.slice);
	var push$1 = functionUncurryThis([].push);
	var numberToString = functionUncurryThis(1.1.toString);
	var surrogates = /[\uD800-\uDFFF]/g;
	var leadingSurrogates = /^[\uD800-\uDBFF]$/;
	var trailingSurrogates = /^[\uDC00-\uDFFF]$/;
	var MARK = uid();
	var MARK_LENGTH = MARK.length;
	var WRONG_SYMBOLS_CONVERSION = !symbolConstructorDetection || fails(function () {
	  var symbol = getBuiltIn('Symbol')('stringify detection');
	  // MS Edge converts symbol values to JSON as {}
	  return $stringify([symbol]) !== '[null]'
	  // WebKit converts symbol values to JSON as null
	  || $stringify({
	    a: symbol
	  }) !== '{}'
	  // V8 throws on boxed symbols
	  || $stringify(Object(symbol)) !== '{}';
	});

	// https://github.com/tc39/proposal-well-formed-stringify
	var ILL_FORMED_UNICODE = fails(function () {
	  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"' || $stringify('\uDEAD') !== '"\\udead"';
	});
	var stringifyWithProperSymbolsConversion = WRONG_SYMBOLS_CONVERSION ? function (it, replacer) {
	  var args = arraySlice(arguments);
	  var $replacer = getReplacerFunction(replacer);
	  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
	  args[1] = function (key, value) {
	    // some old implementations (like WebKit) could pass numbers as keys
	    if (isCallable($replacer)) value = functionCall($replacer, this, $String(key), value);
	    if (!isSymbol(value)) return value;
	  };
	  return functionApply($stringify, null, args);
	} : $stringify;
	var fixIllFormedJSON = function (match, offset, string) {
	  var prev = charAt(string, offset - 1);
	  var next = charAt(string, offset + 1);
	  if (exec(leadingSurrogates, match) && !exec(trailingSurrogates, next) || exec(trailingSurrogates, match) && !exec(leadingSurrogates, prev)) {
	    return '\\u' + numberToString(charCodeAt(match, 0), 16);
	  }
	  return match;
	};
	var getReplacerFunction = function (replacer) {
	  if (isCallable(replacer)) return replacer;
	  if (!isArray(replacer)) return;
	  var rawLength = replacer.length;
	  var keys = [];
	  for (var i = 0; i < rawLength; i++) {
	    var element = replacer[i];
	    if (typeof element == 'string') push$1(keys, element);else if (typeof element == 'number' || classofRaw(element) === 'Number' || classofRaw(element) === 'String') push$1(keys, toString_1(element));
	  }
	  var keysLength = keys.length;
	  var root = true;
	  return function (key, value) {
	    if (root) {
	      root = false;
	      return value;
	    }
	    if (isArray(this)) return value;
	    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
	  };
	};

	// `JSON.stringify` method
	// https://tc39.es/ecma262/#sec-json.stringify
	// https://github.com/tc39/proposal-json-parse-with-source
	if ($stringify) _export({
	  target: 'JSON',
	  stat: true,
	  arity: 3,
	  forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE || !nativeRawJson
	}, {
	  stringify: function stringify(text, replacer, space) {
	    var replacerFunction = getReplacerFunction(replacer);
	    var rawStrings = [];
	    var json = stringifyWithProperSymbolsConversion(text, function (key, value) {
	      // some old implementations (like WebKit) could pass numbers as keys
	      var v = isCallable(replacerFunction) ? functionCall(replacerFunction, this, $String(key), value) : value;
	      return !nativeRawJson && isRawJson(v) ? MARK + (push$1(rawStrings, v.rawJSON) - 1) : v;
	    }, space);
	    if (typeof json != 'string') return json;
	    if (ILL_FORMED_UNICODE) json = replace(json, surrogates, fixIllFormedJSON);
	    if (nativeRawJson) return json;
	    var result = '';
	    var length = json.length;
	    for (var i = 0; i < length; i++) {
	      var chr = charAt(json, i);
	      if (chr === '"') {
	        var end = parseJsonString(json, ++i).end - 1;
	        var string = slice(json, i, end);
	        result += slice(string, 0, MARK_LENGTH) === MARK ? rawStrings[slice(string, MARK_LENGTH)] : '"' + string + '"';
	        i = end;
	      } else result += chr;
	    }
	    return result;
	  }
	});

	var defineBuiltIns = function (target, src, options) {
	  for (var key in src) defineBuiltIn(target, key, src[key], options);
	  return target;
	};

	// `CreateIterResultObject` abstract operation
	// https://tc39.es/ecma262/#sec-createiterresultobject
	var createIterResultObject = function (value, done) {
	  return {
	    value: value,
	    done: done
	  };
	};

	var iteratorCloseAll = function (iters, kind, value) {
	  for (var i = iters.length - 1; i >= 0; i--) {
	    if (iters[i] === undefined) continue;
	    try {
	      value = iteratorClose(iters[i].iterator, kind, value);
	    } catch (error) {
	      kind = 'throw';
	      value = error;
	    }
	  }
	  if (kind === 'throw') throw value;
	  return value;
	};

	var IteratorPrototype = iteratorsCore.IteratorPrototype;
	var TO_STRING_TAG = wellKnownSymbol('toStringTag');
	var ITERATOR_HELPER = 'IteratorHelper';
	var WRAP_FOR_VALID_ITERATOR = 'WrapForValidIterator';
	var NORMAL = 'normal';
	var THROW = 'throw';
	var setInternalState = internalState.set;
	var createIteratorProxyPrototype = function (IS_ITERATOR) {
	  var getInternalState = internalState.getterFor(IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER);
	  return defineBuiltIns(objectCreate(IteratorPrototype), {
	    next: function next() {
	      var state = getInternalState(this);
	      // for simplification:
	      //   for `%WrapForValidIteratorPrototype%.next` or with `state.returnHandlerResult` our `nextHandler` returns `IterResultObject`
	      //   for `%IteratorHelperPrototype%.next` - just a value
	      if (IS_ITERATOR) return state.nextHandler();
	      if (state.done) return createIterResultObject(undefined, true);
	      try {
	        var result = state.nextHandler();
	        return state.returnHandlerResult ? result : createIterResultObject(result, state.done);
	      } catch (error) {
	        state.done = true;
	        throw error;
	      }
	    },
	    'return': function () {
	      var state = getInternalState(this);
	      var iterator = state.iterator;
	      var done = state.done;
	      state.done = true;
	      if (IS_ITERATOR) {
	        var returnMethod = getMethod(iterator, 'return');
	        return returnMethod ? functionCall(returnMethod, iterator) : createIterResultObject(undefined, true);
	      }
	      if (done) return createIterResultObject(undefined, true);
	      if (state.inner) try {
	        iteratorClose(state.inner.iterator, NORMAL);
	      } catch (error) {
	        return iteratorClose(iterator, THROW, error);
	      }
	      if (state.openIters) try {
	        iteratorCloseAll(state.openIters, NORMAL);
	      } catch (error) {
	        if (iterator) return iteratorClose(iterator, THROW, error);
	        throw error;
	      }
	      if (iterator) iteratorClose(iterator, NORMAL);
	      return createIterResultObject(undefined, true);
	    }
	  });
	};
	var WrapForValidIteratorPrototype = createIteratorProxyPrototype(true);
	var IteratorHelperPrototype = createIteratorProxyPrototype(false);
	createNonEnumerableProperty(IteratorHelperPrototype, TO_STRING_TAG, 'Iterator Helper');
	var iteratorCreateProxy = function (nextHandler, IS_ITERATOR, RETURN_HANDLER_RESULT) {
	  var IteratorProxy = function Iterator(record, state) {
	    if (state) {
	      state.iterator = record.iterator;
	      state.next = record.next;
	    } else state = record;
	    state.type = IS_ITERATOR ? WRAP_FOR_VALID_ITERATOR : ITERATOR_HELPER;
	    state.returnHandlerResult = !!RETURN_HANDLER_RESULT;
	    state.nextHandler = nextHandler;
	    state.counter = 0;
	    state.done = false;
	    setInternalState(this, state);
	  };
	  IteratorProxy.prototype = IS_ITERATOR ? WrapForValidIteratorPrototype : IteratorHelperPrototype;
	  return IteratorProxy;
	};

	// call something on iterator step with safe closing on error
	var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
	  try {
	    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
	  } catch (error) {
	    iteratorClose(iterator, 'throw', error);
	  }
	};

	// Should throw an error on invalid iterator
	// https://issues.chromium.org/issues/336839115
	var iteratorHelperThrowsOnInvalidIterator = function (methodName, argument) {
	  // eslint-disable-next-line es/no-iterator -- required for testing
	  var method = typeof Iterator == 'function' && Iterator.prototype[methodName];
	  if (method) try {
	    method.call({
	      next: null
	    }, argument).next();
	  } catch (error) {
	    return true;
	  }
	};

	var FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('filter', function () {/* empty */});
	var filterWithoutClosingOnEarlyError = !FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('filter', TypeError);
	var FORCED$1 = FILTER_WITHOUT_THROWING_ON_INVALID_ITERATOR || filterWithoutClosingOnEarlyError;
	var IteratorProxy$1 = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var predicate = this.predicate;
	  var next = this.next;
	  var result, done, value;
	  while (true) {
	    result = anObject(functionCall(next, iterator));
	    done = this.done = !!result.done;
	    if (done) return;
	    value = result.value;
	    if (callWithSafeIterationClosing(iterator, predicate, [value, this.counter++], true)) return value;
	  }
	});

	// `Iterator.prototype.filter` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.filter
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FORCED$1
	}, {
	  filter: function filter(predicate) {
	    anObject(this);
	    try {
	      aCallable(predicate);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (filterWithoutClosingOnEarlyError) return functionCall(filterWithoutClosingOnEarlyError, this, predicate);
	    return new IteratorProxy$1(getIteratorDirect(this), {
	      predicate: predicate
	    });
	  }
	});

	var MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR = !iteratorHelperThrowsOnInvalidIterator('map', function () {/* empty */});
	var mapWithoutClosingOnEarlyError = !MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR && iteratorHelperWithoutClosingOnEarlyError('map', TypeError);
	var FORCED = MAP_WITHOUT_THROWING_ON_INVALID_ITERATOR || mapWithoutClosingOnEarlyError;
	var IteratorProxy = iteratorCreateProxy(function () {
	  var iterator = this.iterator;
	  var result = anObject(functionCall(this.next, iterator));
	  var done = this.done = !!result.done;
	  if (!done) return callWithSafeIterationClosing(iterator, this.mapper, [result.value, this.counter++], true);
	});

	// `Iterator.prototype.map` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.map
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FORCED
	}, {
	  map: function map(mapper) {
	    anObject(this);
	    try {
	      aCallable(mapper);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    if (mapWithoutClosingOnEarlyError) return functionCall(mapWithoutClosingOnEarlyError, this, mapper);
	    return new IteratorProxy(getIteratorDirect(this), {
	      mapper: mapper
	    });
	  }
	});

	var $TypeError$1 = TypeError;

	// https://bugs.webkit.org/show_bug.cgi?id=291651
	var FAILS_ON_INITIAL_UNDEFINED = fails(function () {
	  // eslint-disable-next-line es/no-iterator-prototype-reduce, es/no-array-prototype-keys, array-callback-return -- required for testing
	  [].keys().reduce(function () {/* empty */}, undefined);
	});
	var reduceWithoutClosingOnEarlyError = !FAILS_ON_INITIAL_UNDEFINED && iteratorHelperWithoutClosingOnEarlyError('reduce', $TypeError$1);

	// `Iterator.prototype.reduce` method
	// https://tc39.es/ecma262/#sec-iterator.prototype.reduce
	_export({
	  target: 'Iterator',
	  proto: true,
	  real: true,
	  forced: FAILS_ON_INITIAL_UNDEFINED || reduceWithoutClosingOnEarlyError
	}, {
	  reduce: function reduce(reducer /* , initialValue */) {
	    anObject(this);
	    try {
	      aCallable(reducer);
	    } catch (error) {
	      iteratorClose(this, 'throw', error);
	    }
	    var noInitial = arguments.length < 2;
	    var accumulator = noInitial ? undefined : arguments[1];
	    if (reduceWithoutClosingOnEarlyError) {
	      return functionApply(reduceWithoutClosingOnEarlyError, this, noInitial ? [reducer] : [reducer, accumulator]);
	    }
	    var record = getIteratorDirect(this);
	    var counter = 0;
	    iterate(record, function (value) {
	      if (noInitial) {
	        noInitial = false;
	        accumulator = value;
	      } else {
	        accumulator = reducer(accumulator, value, counter);
	      }
	      counter++;
	    }, {
	      IS_RECORD: true
	    });
	    if (noInitial) throw new $TypeError$1('Reduce of empty iterator with no initial value');
	    return accumulator;
	  }
	});

	var $TypeError = TypeError;
	var validateArgumentsLength = function (passed, required) {
	  if (passed < required) throw new $TypeError('Not enough arguments');
	  return passed;
	};

	var $URLSearchParams$1 = URLSearchParams;
	var URLSearchParamsPrototype$2 = $URLSearchParams$1.prototype;
	var append = functionUncurryThis(URLSearchParamsPrototype$2.append);
	var $delete = functionUncurryThis(URLSearchParamsPrototype$2['delete']);
	var forEach$1 = functionUncurryThis(URLSearchParamsPrototype$2.forEach);
	var push = functionUncurryThis([].push);
	var params$1 = new $URLSearchParams$1('a=1&a=2&b=3');
	params$1['delete']('a', 1);
	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	params$1['delete']('b', undefined);
	if (params$1 + '' !== 'a=2') {
	  defineBuiltIn(URLSearchParamsPrototype$2, 'delete', function (name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $delete(this, name);
	    var entries = [];
	    forEach$1(this, function (v, k) {
	      // also validates `this`
	      push(entries, {
	        key: k,
	        value: v
	      });
	    });
	    validateArgumentsLength(length, 1);
	    var key = toString_1(name);
	    var value = toString_1($value);
	    var index = 0;
	    var entriesLength = entries.length;
	    var entry;
	    while (index < entriesLength) {
	      entry = entries[index];
	      $delete(this, entry.key);
	      index++;
	    }
	    index = 0;
	    while (index < entriesLength) {
	      entry = entries[index++];
	      if (!(entry.key === key && entry.value === value)) append(this, entry.key, entry.value);
	    }
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var $URLSearchParams = URLSearchParams;
	var URLSearchParamsPrototype$1 = $URLSearchParams.prototype;
	var getAll = functionUncurryThis(URLSearchParamsPrototype$1.getAll);
	var $has = functionUncurryThis(URLSearchParamsPrototype$1.has);
	var params = new $URLSearchParams('a=1');

	// `undefined` case is a Chromium 117 bug
	// https://bugs.chromium.org/p/v8/issues/detail?id=14222
	if (params.has('a', 2) || !params.has('a', undefined)) {
	  defineBuiltIn(URLSearchParamsPrototype$1, 'has', function has(name /* , value */) {
	    var length = arguments.length;
	    var $value = length < 2 ? undefined : arguments[1];
	    if (length && $value === undefined) return $has(this, name);
	    var values = getAll(this, name); // also validates `this`
	    validateArgumentsLength(length, 1);
	    var value = toString_1($value);
	    var index = 0;
	    while (index < values.length) {
	      if (values[index++] === value) return true;
	    }
	    return false;
	  }, {
	    enumerable: true,
	    unsafe: true
	  });
	}

	var URLSearchParamsPrototype = URLSearchParams.prototype;
	var forEach = functionUncurryThis(URLSearchParamsPrototype.forEach);

	// `URLSearchParams.prototype.size` getter
	// https://github.com/whatwg/url/pull/734
	if (descriptors && !('size' in URLSearchParamsPrototype)) {
	  defineBuiltInAccessor(URLSearchParamsPrototype, 'size', {
	    get: function size() {
	      var count = 0;
	      forEach(this, function () {
	        count++;
	      });
	      return count;
	    },
	    configurable: true,
	    enumerable: true
	  });
	}

	var BN = {
		name: "Bunny",
		imgPath: "/img/statistics/bunny.svg",
		cacheHitRate: 99.61,
		color: "#3370EB",
		enabled: true
	};
	var CF = {
		name: "Cloudflare",
		imgPath: "/img/statistics/cloudflare.svg",
		cacheHitRate: 99.49,
		color: "#F6821F",
		enabled: true
	};
	var FY = {
		name: "Fastly",
		imgPath: "/img/statistics/fastly.svg",
		cacheHitRate: 99.43,
		color: "#FF282D",
		enabled: true
	};
	var GC = {
		name: "GCore",
		imgPath: "/img/statistics/g-core.svg",
		cacheHitRate: 98.93,
		color: "#A234D2",
		enabled: true
	};
	var MX = {
		name: "StackPath",
		cacheHitRate: 99.24,
		imgPath: "/img/statistics/stackpath.svg",
		color: "#106534",
		enabled: false
	};
	var QT = {
		name: "Quantil",
		imgPath: "/img/statistics/quantil.ico",
		cacheHitRate: 99.18,
		color: "#961C1F",
		enabled: false
	};
	var combinedProviders = {
		name: "Combined Providers",
		imgPath: "/img/statistics/stackpath.ico",
		color: "#F65128",
		enabled: false
	};
	var netProviders = {
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders
	};

	var netProviders$1 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		BN: BN,
		CF: CF,
		FY: FY,
		GC: GC,
		MX: MX,
		QT: QT,
		combinedProviders: combinedProviders,
		'default': netProviders
	});

	var newHost = "img.jsdelivr.com";
	var hosts = [
		"cloud.githubusercontent.com",
		"img.shields.io",
		"img.badgesize.io",
		"raw.githubusercontent.com",
		"github.com",
		"upload.wikimedia.org",
		"opencollective.com",
		"flat.badgen.net",
		"images.opencollective.com",
		"avatars.githubusercontent.com",
		"badgen.net"
	];
	var optimizedHosts$1 = {
		newHost: newHost,
		hosts: hosts
	};

	var optimizedHosts$2 = /*#__PURE__*/Object.freeze({
		__proto__: null,
		newHost: newHost,
		hosts: hosts,
		'default': optimizedHosts$1
	});

	var providersJson = getCjsExportFromNamespace(netProviders$1);

	var optimizedHosts = getCjsExportFromNamespace(optimizedHosts$2);

	var _ = createCommonjsModule(function (module) {
	  const MONTHS_SHORT_NAMES_LIST = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	  const MONTHS_FULL_NAMES_LIST = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	  const DAY_NAME_NUMBER_MAP = {
	    Mon: 0,
	    Tue: 1,
	    Wed: 2,
	    Thu: 3,
	    Fri: 4,
	    Sat: 5,
	    Sun: 6
	  };
	  const MONTH_NAME_NUMBER_MAP = {
	    Jan: 0,
	    Feb: 1,
	    Mar: 2,
	    Apr: 3,
	    May: 4,
	    Jun: 5,
	    Jul: 6,
	    Aug: 7,
	    Sep: 8,
	    Oct: 9,
	    Nov: 10,
	    Dec: 11
	  };
	  const MONTH_FULL_OF_DAYS = '31';
	  const MONTH_SHORT_OF_DAYS = '30';
	  const MONTH_FEB_DAYS = '28';
	  const MONTH_LEAP_FEB_DAYS = '29';
	  const screenType = {
	    mobile: 480,
	    tablet: 768,
	    mdDesktop: 992,
	    lgDesktop: 1200,
	    xlDesktop: 1400
	  };
	  module.exports = {
	    screenType,
	    isTabletScreen() {
	      return screen.width > screenType.mobile && screen.width <= screenType.tablet;
	    },
	    isMobileScreen() {
	      return screen.width <= screenType.mobile;
	    },
	    calculateGrowth(curr, prev) {
	      if (!prev) {
	        return 0;
	      }
	      return curr / prev * 100 - 100;
	    },
	    getValueFormatter(isBandwidth, values) {
	      if (!isBandwidth) {
	        return module.exports.formatNumber;
	      }
	      let unit = module.exports.findUnitFromArray(values);
	      return value => module.exports.formatBytesWithUnit(value, unit);
	    },
	    flattenFiles: function flattenFiles(tree, path = '/', files = []) {
	      tree.forEach(item => {
	        if (item.type === 'file') {
	          files.push(path + item.name);
	        } else {
	          flattenFiles(item.files, path + item.name + '/', files);
	        }
	      });
	      return files;
	    },
	    formatDate(date, format = 'long') {
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      if (format === 'short') {
	        return date.toLocaleDateString('en-US', {
	          day: 'numeric',
	          month: 'short'
	        });
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric'
	      });
	    },
	    formatDateTime(date) {
	      if (!date) {
	        return '';
	      }
	      if (typeof date === 'string') {
	        date = new Date(date);
	      }
	      return date.toLocaleDateString('en-US', {
	        day: 'numeric',
	        month: 'short',
	        year: 'numeric',
	        hour: 'numeric',
	        minute: 'numeric',
	        second: 'numeric',
	        hour12: false
	      });
	    },
	    formatHits(hits) {
	      if (hits < 1e9) {
	        return 1;
	      }
	      return Math.round(hits / 1e9);
	    },
	    formatNumber(number) {
	      return Math.floor(number).toString().replace(/\d(?=(?:\d{3})+$)/g, '$& ');
	    },
	    formatNumberWithSpace(val) {
	      // remove sign if negative
	      let sign = 1;
	      if (val < 0) {
	        sign = -1;
	        val = -val;
	      }
	      let num = val.toString().includes('.') ? val.toString().split('.')[0] : val.toString();
	      while (/(\d+)(\d{3})/.test(num.toString())) {
	        num = num.toString().replace(/(\d+)(\d{3})/, '$1 $2');
	      }
	      if (val.toString().includes('.')) {
	        num = num + '.' + val.toString().split('.')[1];
	      }
	      return sign < 0 ? '-' + num : num;
	    },
	    getMinifiedName(name) {
	      return name.replace(/\.(js|css)$/i, '.min.$1');
	    },
	    getNonMinifiedName(name) {
	      return name.replace(/\.min\.(js|css)$/i, '.$1');
	    },
	    listFiles: function listFiles(files = [], path) {
	      if (!path.length) {
	        return files;
	      }
	      let p = path.slice();
	      let n = p.shift();
	      let d = files.filter(f => f.name === n)[0];
	      return d && d.files ? listFiles(d.files, p) : null;
	    },
	    nth(n) {
	      n = Math.floor(n);
	      let m = n % 10;
	      if (n === 1) {
	        return '';
	      } else if (n > 20 && m === 1) {
	        return `${n}st`;
	      } else if (n === 2 || n > 20 && m === 2) {
	        return `${n}nd`;
	      } else if (n === 3 || n > 20 && m === 3) {
	        return `${n}rd`;
	      }
	      return `${n}th`;
	    },
	    getChartXAxisData(periodDates, period = 'month', periodGroupBy = 'day') {
	      let chartXData = [];
	      let dataPerMonths = periodDates.reduce((dataPerMonths, date) => {
	        let splittedDate = date.split('-');
	        let dateYear = splittedDate[0];
	        let dateMonth = splittedDate.slice(0, 2).join('-');
	        let periodMonthFormatted = MONTHS_SHORT_NAMES_LIST[new Date(dateMonth).getUTCMonth()];
	        if (!dataPerMonths[`${dateYear} ${periodMonthFormatted}`]) {
	          dataPerMonths[`${dateYear} ${periodMonthFormatted}`] = [];
	        }
	        dataPerMonths[`${dateYear} ${periodMonthFormatted}`].push(date);
	        return dataPerMonths;
	      }, []);
	      let labelArea = 0;
	      Object.keys(dataPerMonths).forEach(yearMonthKey => {
	        // let middleLength = Math.round(dataPerMonths[yearMonthKey].length / 2);

	        dataPerMonths[yearMonthKey].forEach((day, idx) => {
	          // for every case except we set month in the start of the days
	          // if period is year we should return month for every day since it will be filtered on ticks callback as needed
	          let year = yearMonthKey.split(' ')[0];
	          let month = yearMonthKey.split(' ')[1];
	          labelArea++;
	          if (period === 'year') {
	            if (idx === 0) {
	              if (periodGroupBy === 'day' && dataPerMonths[yearMonthKey].length > 15 && labelArea < 359) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'week' && labelArea > 0 && labelArea < 54) {
	                chartXData.push([day, month, year]);
	                return;
	              } else if (periodGroupBy === 'month' && labelArea < 12) {
	                chartXData.push([day, month, year]);
	                return;
	              }
	            }
	            if (periodGroupBy !== 'month') {
	              chartXData.push([day, '', '']);
	            }
	          } else if (idx === 0) {
	            if (periodGroupBy === 'month') {
	              chartXData.push(['', month]);
	            } else if (dataPerMonths[yearMonthKey].length > 1) {
	              chartXData.push([day, month]);
	            }
	          } else {
	            chartXData.push([day, '']);
	          }
	        });
	      });
	      return chartXData;
	    },
	    // escaping code: https://github.com/component/escape-html/blob/master/index.js
	    unescapeHtml(text) {
	      return text.replace(/&quot;/g, '"').replace(/&amp;/g, '&').replace(/&#39;/g, '\'').replace(/&lt;/g, '<').replace(/&gt;/g, '>');
	    },
	    // ignoreExtremlySmallValue: true when you need to find min value for the axis min e.g.
	    getValueByMagnitude(value, rounding = 'round', magnitudeCorrection = 0, ignoreExtremlySmallValue = true) {
	      let magnitude = Math.floor(Math.log10(value) === -Infinity ? 0 : Math.log10(value)) - magnitudeCorrection;
	      if (ignoreExtremlySmallValue && value < 10) {
	        return rounding === 'ceil' ? 10 : 0;
	      }
	      switch (rounding) {
	        case 'round':
	          return Math.round(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'ceil':
	          return Math.ceil(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	        case 'floor':
	          return Math.floor(value / Math.pow(10, magnitude)) * Math.pow(10, magnitude);
	      }
	    },
	    convertBytesToUnits(bytesAmount, units = 'GB') {
	      let unitsBase = 1;
	      switch (units) {
	        case 'kB':
	          unitsBase = 1e3;
	          break;
	        case 'MB':
	          unitsBase = 1e6;
	          break;
	        case 'GB':
	          unitsBase = 1e9;
	          break;
	        case 'TB':
	          unitsBase = 1e12;
	          break;
	        case 'PB':
	          unitsBase = 1e15;
	          break;
	        case 'EB':
	          unitsBase = 1e18;
	          break;
	      }
	      return Math.round(bytesAmount / unitsBase);
	    },
	    findUnitFromArray(numbers) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      return numbers.map(num => {
	        return lookup.slice().reverse().find(item => {
	          return num >= item.value;
	        });
	      }).sort((a, b) => a.value - b.value)[0].symbol;
	    },
	    findUnitFromNumber(num) {
	      let lookup = [{
	        value: 1e4,
	        symbol: 'kB'
	      }, {
	        value: 1e7,
	        symbol: 'MB'
	      }, {
	        value: 1e10,
	        symbol: 'GB'
	      }, {
	        value: 1e13,
	        symbol: 'TB'
	      }, {
	        value: 1e16,
	        symbol: 'PB'
	      }, {
	        value: 1e19,
	        symbol: 'EB'
	      }];
	      let unit = lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      if (!unit) {
	        return 'B';
	      }
	      return unit.symbol;
	    },
	    formatBytesWithUnit(num, unit) {
	      let lookup = [{
	        value: 1,
	        symbol: 'B'
	      }, {
	        value: 1e3,
	        symbol: 'kB'
	      }, {
	        value: 1e6,
	        symbol: 'MB'
	      }, {
	        value: 1e9,
	        symbol: 'GB'
	      }, {
	        value: 1e12,
	        symbol: 'TB'
	      }, {
	        value: 1e15,
	        symbol: 'PB'
	      }, {
	        value: 1e18,
	        symbol: 'EB'
	      }];
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? module.exports.formatNumber(num / item.value) + ' ' + item.symbol : '0';
	    },
	    formatGrowth(num, fixed = 1) {
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `+0%`;
	      }
	      return `${num >= 0 ? '+' : ''}${num.toFixed(fixed)}%`;
	    },
	    formatShare(num, fixed = 1) {
	      if (num === 0 || num.toFixed(fixed) === '0') {
	        return `0%`;
	      }
	      return `${num.toFixed(fixed)}%`;
	    },
	    formatToShortNumber(num, delimiter = '', unit) {
	      let lookup = [{
	        value: 1,
	        symbol: ''
	      }, {
	        value: 1e3,
	        symbol: 'K'
	      }, {
	        value: 1e6,
	        symbol: 'M'
	      }, {
	        value: 1e9,
	        symbol: 'B'
	      }, {
	        value: 1e12,
	        symbol: 'T'
	      }, {
	        value: 1e15,
	        symbol: 'P'
	      }, {
	        value: 1e18,
	        symbol: 'E'
	      }];
	      let rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	      let item = lookup.find(l => l.symbol === unit) || lookup.slice().reverse().find(item => {
	        return num >= item.value;
	      });
	      return item ? (num / item.value).toFixed(1).replace(rx, '$1') + delimiter + item.symbol : '0';
	    },
	    makeHTTPRequest(obj) {
	      let {
	        method = 'GET',
	        rawResponse = false,
	        body,
	        url,
	        headers,
	        responseHeadersToGet = null,
	        withCredentials = false
	      } = obj;
	      return new Promise((resolve, reject) => {
	        let xhr = new XMLHttpRequest();
	        xhr.open(method || 'GET', method === 'GET' && body ? url + this.createQueryString(body) : url);
	        if (method === 'POST') {
	          xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8');
	        }
	        if (headers) {
	          Object.keys(headers).forEach(key => xhr.setRequestHeader(key, headers[key]));
	        }
	        if (withCredentials) {
	          xhr.withCredentials = true;
	        }
	        xhr.onerror = xhr.onload = () => {
	          let response = xhr.response;
	          if (!rawResponse) {
	            try {
	              response = JSON.parse(response);
	            } catch (e) {
	              console.error(e);
	            }
	          }
	          let responseHeaders = responseHeadersToGet ? responseHeadersToGet.reduce((headerValuePairs, headerName) => {
	            headerValuePairs[headerName] = xhr.getResponseHeader(headerName);
	            return headerValuePairs;
	          }, {}) : null;
	          if (xhr.status >= 200 && xhr.status < 300) {
	            let resolveData;
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              resolveData = {
	                response,
	                responseHeaders
	              };
	            } else {
	              resolveData = response;
	            }
	            resolve(resolveData);
	          } else {
	            let rejectData = {
	              ...response,
	              responseStatusCode: xhr.status
	            };
	            if (responseHeaders && Object.keys(responseHeaders).length) {
	              rejectData = {
	                ...rejectData,
	                responseHeaders
	              };
	            }
	            reject(rejectData);
	          }
	        };
	        if (method === 'GET') {
	          xhr.send();
	        } else if (method === 'POST') {
	          xhr.send(JSON.stringify(body));
	        }
	      });
	    },
	    createQueryString(params) {
	      let keys = Object.keys(params);
	      if (!keys.length) {
	        return '';
	      }
	      return '?' + keys.filter(key => params[key]).map(key => `${key}=${encodeURIComponent(params[key])}`).join('&');
	    },
	    deepExtend(out = {}, ...rest) {
	      for (let i = 0; i < rest.length; i++) {
	        let obj = rest[i];
	        if (!obj) {
	          continue;
	        }
	        for (let key in obj) {
	          if (Object.hasOwn(obj, key)) {
	            if (typeof obj[key] === 'object' && obj[key] !== null) {
	              if (obj[key] instanceof Array) {
	                out[key] = obj[key].slice(0);
	              } else {
	                out[key] = this.deepExtend(out[key], obj[key]);
	              }
	            } else {
	              out[key] = obj[key];
	            }
	          }
	        }
	      }
	      return out;
	    },
	    onDocumentReady(fn) {
	      if (document.readyState !== 'loading') {
	        fn();
	      } else {
	        document.addEventListener('DOMContentLoaded', fn);
	      }
	    },
	    checkIfYearIsLeap(year) {
	      if (isNaN(Number(year)) || String(year).length !== 4) {
	        console.warn('Func isLeapYear expected a year as a String or a Number with 4 signs');
	        return false;
	      }
	      if (year % 4 === 0) {
	        if (year % 100 === 0) {
	          if (year % 400 === 0) {
	            return true;
	          }
	          return false;
	        }
	        return true;
	      }
	      return false;
	    },
	    getAmountOfDaysByMonth(month, year) {
	      switch (month) {
	        case '01':
	        case '03':
	        case '05':
	        case '07':
	        case '08':
	        case '10':
	        case '12':
	          return MONTH_FULL_OF_DAYS;
	        case '04':
	        case '06':
	        case '09':
	        case '11':
	          return MONTH_SHORT_OF_DAYS;
	        case '02':
	          return this.checkIfYearIsLeap(year) ? MONTH_LEAP_FEB_DAYS : MONTH_FEB_DAYS;
	      }
	    },
	    getDateFormats(date) {
	      let splittedDate = date.split('-');
	      let dateYear = splittedDate[0];
	      let dateMonth = splittedDate[1];
	      let dateDay = splittedDate[2];
	      let parsedDateDay = parseInt(splittedDate[2]);
	      let dateDayName = new Date(Date.UTC(Number(dateYear), Number(dateMonth) - 1, Number(dateDay))).toLocaleDateString('en-US', {
	        weekday: 'short'
	      });
	      let periodMonthShort = MONTHS_SHORT_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      let periodMonthFull = MONTHS_FULL_NAMES_LIST[new Date(`${dateYear}-${dateMonth}`).getUTCMonth()];
	      return {
	        dateYear,
	        dateMonth,
	        dateDay,
	        dateDayName,
	        periodMonthShort,
	        periodMonthFull,
	        parsedDateDay
	      };
	    },
	    prepareDataForChartGroupedBy(rawData, groupBy, valueByDatePropName = '') {
	      let rawDataDatesKeys = Object.keys(rawData.dates);
	      let rawDataDatesData = rawData.dates;
	      return rawDataDatesKeys.reduce((resData, date) => {
	        let {
	          dateYear,
	          dateMonth,
	          dateDay,
	          dateDayName,
	          periodMonthShort,
	          periodMonthFull,
	          parsedDateDay
	        } = this.getDateFormats(date);
	        let valueByDateConverted = valueByDatePropName ? rawDataDatesData[date][valueByDatePropName] : rawDataDatesData[date];
	        switch (groupBy) {
	          case 'month':
	            if (!resData.preparedData[dateMonth]) {
	              resData.preparedData[dateMonth] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	            } else {
	              let lastDayNum = this.getAmountOfDaysByMonth(dateMonth, dateYear);
	              resData.preparedData[dateMonth].value += valueByDateConverted;
	              if (dateDay === lastDayNum) {
	                resData.preparedData[dateMonth].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	                if (resData.preparedData[dateMonth].day === `01`) {
	                  resData.preparedData[dateMonth].isFull = true;
	                }
	              }
	            }
	            return resData;
	          case 'week':
	            if (!resData.preparedData[resData.weekNumber]) {
	              resData.preparedData[resData.weekNumber] = {
	                isFull: false,
	                value: valueByDateConverted,
	                day: dateDay,
	                month: periodMonthShort,
	                year: dateYear,
	                periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	                periodEnd: null
	              };
	              resData.weekDayCnt = 1;
	            } else {
	              resData.preparedData[resData.weekNumber].value += valueByDateConverted;
	              resData.weekDayCnt++;
	              if (resData.weekDayCnt === 7) {
	                resData.preparedData[resData.weekNumber].isFull = true;
	                resData.preparedData[resData.weekNumber].periodEnd = `${periodMonthFull} ${parsedDateDay}, ${dateYear}`;
	              }
	            }
	            if (DAY_NAME_NUMBER_MAP[dateDayName] === 6) {
	              resData.weekNumber++;
	            }
	            return resData;
	          case 'day':
	            if (!resData.preparedData.days) {
	              resData.preparedData.days = [];
	            }
	            resData.preparedData.days.push({
	              value: valueByDateConverted,
	              day: dateDay,
	              month: periodMonthShort,
	              year: dateYear,
	              periodStart: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`,
	              periodEnd: `${periodMonthFull} ${parsedDateDay}, ${dateYear}`
	            });
	            return resData;
	        }
	        return resData;
	      }, {
	        weekNumber: 0,
	        weekDayCnt: 0,
	        preparedData: {}
	      });
	    },
	    createWeekPeriodChartLabels(labels) {
	      // for both Mobile and Desktop we will show Day and Month per each tick
	      // no matter what resolution is
	      return labels.map(label => {
	        return label.slice(0, 2);
	      });
	    },
	    createMonthPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [];
	      if (groupBy === 'day') {
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0 || label[0] === '01') {
	                return label.slice(0, 2);
	              }
	              return label.slice(0, 1);
	            case idx === Math.round(labels.length / 2):
	            case idx === 0:
	              return label.slice(0, 2);
	            default:
	              return [];
	          }
	        });
	      }
	      if (groupBy === 'week') {
	        formattedLabels = labels;
	      }
	      return formattedLabels;
	    },
	    createYearPeriodChartLabels(labels, groupBy) {
	      let formattedLabels = [...labels];
	      if (groupBy === 'day') {
	        let tempCurrMonth = labels[0][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          switch (true) {
	            case screen.width >= 992:
	              if (idx === 0) {
	                return label.slice(1, 3);
	              } else if (label[2] !== currAxisYear && label[1] !== tempCurrMonth) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return label.slice(1, 3);
	              } else if (label[1] !== tempCurrMonth && label[2] === currAxisYear) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case idx === 0 || idx === labels.length - 1:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'week') {
	        let tempCurrMonth = labels[0][1];
	        let lastPeriodMonth = labels[labels.length - 1][1];
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          let isEdgeLabel = idx === 0 || idx === labels.length - 1;
	          switch (true) {
	            case screen.width >= 768:
	              if (isEdgeLabel || label[2] !== currAxisYear) {
	                currAxisYear = label[2];
	                tempCurrMonth = label[1];
	                return isEdgeLabel || label[1] !== lastPeriodMonth ? label.slice(1, 3) : [];
	              } else if (label[1] !== tempCurrMonth && label[1] !== lastPeriodMonth) {
	                tempCurrMonth = label[1];
	                return label.slice(1, 2);
	              }
	              return [];
	            case isEdgeLabel:
	              return label.slice(1, 3);
	          }
	          return [];
	        });
	      }
	      if (groupBy === 'month') {
	        let currAxisYear = labels[0][2];
	        formattedLabels = labels.map((label, idx) => {
	          if (idx === 0 || idx === labels.length - 1 || label[2] !== currAxisYear) {
	            currAxisYear = label[2];
	            return label.slice(1, 3);
	          }
	          if (screen.width < 768) {
	            return [];
	          }
	          return label.slice(1, 2);
	        });
	      }
	      return formattedLabels;
	    },
	    getSortedIterableChartData(data, groupBy) {
	      let toSort = groupBy === 'day' ? data.days : Object.values(data);
	      let getDate = value => {
	        return new Date(Number(value.year), MONTH_NAME_NUMBER_MAP[value.month], Number(value.day));
	      };
	      return toSort.sort((a, b) => getDate(a) - getDate(b));
	    },
	    // take preparedData for charts and then group it by day/week/month, calc magnitude, create labels for x-axis
	    getPreparedDataForBarChart(rawData, groupBy, chartPeriod, showChartBandwidth, onlyFullPeriods = true) {
	      let {
	        preparedData
	      } = this.prepareDataForChartGroupedBy(rawData, groupBy);
	      let results = {
	        values: [],
	        labels: [],
	        labelsStartEndPeriods: [],
	        minRangeValue: 0,
	        maxRangeValue: 0,
	        valueUnits: ''
	      };
	      let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);

	      // collect data for chart depending on groupBy
	      results = dataToIterate.reduce((res, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return res;
	        }
	        res.values.push(period.value);
	        res.labels.push([period.day, period.month, period.year]);
	        res.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return res;
	      }, results);
	      if (showChartBandwidth) {
	        let unit = module.exports.findUnitFromArray(results.values);
	        results.values = results.values.map(v => module.exports.convertBytesToUnits(v, unit));
	        results.valueUnits = ` ${unit}`;
	      }

	      // get min/max magnitude for y-axis
	      results.minRangeValue = this.getValueByMagnitude(Math.min(...results.values), 'floor');
	      results.maxRangeValue = this.getValueByMagnitude(Math.max(...results.values), 'ceil', 1);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          results.labels = this.createWeekPeriodChartLabels(results.labels);
	          break;
	        case 's-month':
	          results.labels = this.createMonthPeriodChartLabels(results.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          results.labels = this.createYearPeriodChartLabels(results.labels, groupBy);
	          break;
	      }
	      return results;
	    },
	    calcChartBarThicknessByResolution(chartPeriod = 'month', usageChartGroupBy = 'day') {
	      let sreenWidth = screen.width;
	      let schema = {
	        thinnestBar: 1,
	        thinBar: 2,
	        regularBar: 4,
	        wideBar: 10
	      };
	      switch (chartPeriod) {
	        case 's-week':
	          return schema.wideBar;
	        case 's-month':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 576) {
	                return schema.wideBar;
	              }
	              return schema.regularBar;
	            case 'week':
	              return schema.wideBar;
	          }
	          break;
	        case 's-quarter':
	          switch (usageChartGroupBy) {
	            case 'day':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'week':
	              return schema.regularBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        case 's-year':
	          switch (usageChartGroupBy) {
	            case 'day':
	              return schema.thinnestBar;
	            case 'week':
	              if (sreenWidth >= 768) {
	                return schema.regularBar;
	              }
	              return schema.thinBar;
	            case 'month':
	              return schema.wideBar;
	          }
	          break;
	        default:
	          return schema.regularBar;
	      }
	    },
	    // prepare data for Providers Line Chart
	    getPreparedProvidersDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth, onlyFullPeriods = true) {
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let valueUnits = '',
	        unit;
	      let sortedProviders = rawData[dataType].providers.sort((a, b) => b.total - a.total);
	      let topProviderData = sortedProviders[0] || {};
	      let {
	        preparedData: topProviderPrepData
	      } = this.prepareDataForChartGroupedBy(topProviderData, groupBy, 'total');
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIterate = this.getSortedIterableChartData(topProviderPrepData, groupBy);

	      // collect labels, period starts/ends data for chart
	      labelsData = dataToIterate.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawData[dataType].providers.reduce((res, providerData) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(providerData, groupBy, 'total');
	        let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);
	        let groupedByValues = dataToIterate.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: providersJson[providerData.code].name,
	          data: groupedByValues,
	          borderColor: providersJson[providerData.code].color,
	          backgroundColor: providersJson[providerData.code].color
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // prepare data for LineChart
	    getPreparedDataForLineChart(rawData, groupBy, chartPeriod, showChartBandwidth, numberOfDatasets = 5, onlyFullPeriods = true, colorsArray = []) {
	      let dataType = showChartBandwidth ? 'bandwidth' : 'hits';
	      let rawDataFiltered = rawData.sort((a, b) => b[dataType].hits - a[dataType].hits).slice(0, numberOfDatasets);
	      let valueUnits = '',
	        unit;
	      // get top by stats version of package to get from it values for y-axis, and labels to x-axis
	      let topVersionData = rawDataFiltered[0][dataType];
	      let {
	        preparedData: topVersionPrepData
	      } = this.prepareDataForChartGroupedBy(topVersionData, groupBy);
	      let labelsData = {
	        labels: [],
	        labelsStartEndPeriods: []
	      };
	      let dataToIterate = this.getSortedIterableChartData(topVersionPrepData, groupBy);

	      // collect labels, period starts/ends adta for chart
	      labelsData = dataToIterate.reduce((labelsData, period) => {
	        if (onlyFullPeriods && period.isFull === false) {
	          return labelsData;
	        }
	        labelsData.labels.push([period.day, period.month, period.year]);
	        labelsData.labelsStartEndPeriods.push([period.periodStart, period.periodEnd, period.value]);
	        return labelsData;
	      }, labelsData);

	      // create labels depending on chartPeriod, Screen size, groupBy
	      switch (chartPeriod) {
	        case 's-week':
	          labelsData.labels = this.createWeekPeriodChartLabels(labelsData.labels);
	          break;
	        case 's-month':
	          labelsData.labels = this.createMonthPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	        case 's-quarter':
	        case 's-year':
	          labelsData.labels = this.createYearPeriodChartLabels(labelsData.labels, groupBy);
	          break;
	      }
	      let {
	        allGroupedByValues,
	        datasets
	      } = rawDataFiltered.reduce((res, versionData, idx) => {
	        let {
	          preparedData
	        } = this.prepareDataForChartGroupedBy(versionData[dataType], groupBy);
	        let dataToIterate = this.getSortedIterableChartData(preparedData, groupBy);
	        let groupedByValues = dataToIterate.reduce((values, period) => {
	          if (onlyFullPeriods && period.isFull === false) {
	            return values;
	          }
	          values.push(period.value);
	          return values;
	        }, []);
	        if (showChartBandwidth) {
	          if (!unit) {
	            unit = module.exports.findUnitFromArray(groupedByValues);
	            valueUnits = ` ${unit}`;
	          }
	          groupedByValues = groupedByValues.map(v => module.exports.convertBytesToUnits(v, unit));
	        }
	        let dataset = {
	          label: this.truncate(versionData.version, 20),
	          data: groupedByValues,
	          borderColor: colorsArray[idx],
	          backgroundColor: colorsArray[idx]
	        };
	        res.datasets.push(dataset);
	        res.allGroupedByValues = [...res.allGroupedByValues, ...groupedByValues];
	        return res;
	      }, {
	        allGroupedByValues: [],
	        datasets: []
	      });

	      // get min/max magnitude for y-axis
	      let maxRangeValue = this.getValueByMagnitude(Math.max(...allGroupedByValues), 'ceil', 1);
	      return {
	        ...labelsData,
	        maxRangeValue,
	        valueUnits,
	        datasets
	      };
	    },
	    // create barChart, lineChart improved tooltip title
	    createImprovedExternalTooltipTitle(periodStart, periodEnd, groupedBy) {
	      if (groupedBy === 'month') {
	        let [monthName,, year] = periodStart.split(' ');
	        return `${monthName}, ${year}`;
	      }
	      return periodStart === periodEnd ? `${periodStart}` : `${periodStart} - ${periodEnd}`;
	    },
	    translatePeriodsToSNotation(periodValue) {
	      switch (periodValue) {
	        case 'month':
	          return 's-month';
	        case 'quarter':
	          return 's-quarter';
	        case 'year':
	          return 's-year';
	        default:
	          return periodValue;
	      }
	    },
	    optimizeSrc(url, github) {
	      let {
	        newHost,
	        hosts
	      } = optimizedHosts;
	      let base = github ? `https://cdn.jsdelivr.net/gh/${github.user}/${github.project}@${github.head}/` : typeof location !== 'undefined' ? location.href : undefined;
	      let parsed = new URL(url.replace(/^\/+/, ''), base);
	      if (hosts.includes(parsed.hostname)) {
	        parsed.pathname = parsed.hostname + parsed.pathname;
	        parsed.hostname = newHost;
	      }
	      return parsed.toString();
	    },
	    normalizeHref(url, idPrefix) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        if (parsed.origin === location.origin && parsed.pathname === location.pathname) {
	          if (parsed.hash) {
	            parsed.hash = `#${idPrefix}${parsed.hash.substr(1)}`;
	          }
	        }
	        return parsed.toString();
	      } catch {
	        return url;
	      }
	    },
	    isExternalLink(url) {
	      try {
	        let parsed = new URL(url.replace(/^\/+/, ''), location.href);
	        return parsed.hostname !== location.hostname;
	      } catch {
	        return false;
	      }
	    },
	    packageToImportName(name) {
	      name = name.split(/[ ._-]/g).reduce((acc, value) => {
	        return acc + value.substr(0, 1).toUpperCase() + value.substr(1);
	      }).replace(/[^a-zA-Z0-9_$]/g, '');
	      if (/^\d/.test(name)) {
	        return `_${name}`;
	      }
	      return name || 'm';
	    },
	    filterListStatPeriods(rawListStatPeriods, filterFor) {
	      if (!filterFor) {
	        return rawListStatPeriods;
	      }
	      return rawListStatPeriods.reduce((res, item) => {
	        if (Object.hasOwn(item.links, 'filterFor')) {
	          res.push(item);
	        }
	        return res;
	      }, []);
	    },
	    prepareFilteredStatPeriods(rawPeriods) {
	      let {
	        prepPeriods
	      } = rawPeriods.reduce((res, rawItem, rawItemIdx) => {
	        let monthQuarterText = '';
	        let {
	          period,
	          periodType
	        } = rawItem;
	        let [year, monthOrQuarter] = period.split('-');
	        if (monthOrQuarter) {
	          monthQuarterText = isNaN(Number(monthOrQuarter)) ? monthOrQuarter : MONTHS_FULL_NAMES_LIST[Number(monthOrQuarter) - 1];
	        }
	        res.prepPeriods.push({
	          periodType,
	          periodText: `${monthQuarterText} ${year}`.trim(),
	          periodValue: period
	        });
	        if (res.yearPointer !== year) {
	          res.yearPointer = year;
	        }

	        // check if next item has different year form current, if so - add separator
	        if (rawPeriods[rawItemIdx + 1] && rawPeriods[rawItemIdx + 1].period.split('-')[0] !== year) {
	          res.prepPeriods.push({
	            periodType: 'separator'
	          });
	        }
	        return res;
	      }, {
	        prepPeriods: [],
	        yearPointer: null
	      });
	      let defaultPeriods = [{
	        periodType: 's-month',
	        periodText: 'month',
	        periodValue: 'month'
	      }, {
	        periodType: 's-quarter',
	        periodText: 'quarter',
	        periodValue: 'quarter'
	      }, {
	        periodType: 's-year',
	        periodText: 'year',
	        periodValue: 'year'
	      }, {
	        periodType: 'separator'
	      }];
	      return defaultPeriods.concat(prepPeriods);
	    },
	    getPreparedListStatPeriods(rawListStatPeriods, filterFor) {
	      let filteredStatPeriods = this.filterListStatPeriods(rawListStatPeriods, filterFor);
	      return this.prepareFilteredStatPeriods(filteredStatPeriods);
	    },
	    truncate(text, length) {
	      if (text.length <= length) {
	        return text;
	      }
	      return `${text.substr(0, length - 3)}...`;
	    },
	    capitalizeFirstLetter(word) {
	      return word ? word[0].toUpperCase() + word.slice(1) : '';
	    },
	    capitalizeStrEveryFirstLetter(string, exclude = []) {
	      return string.split(' ').reduce((res, w) => {
	        if (exclude.includes(w)) {
	          res.push(w);
	        } else {
	          res.push(this.capitalizeFirstLetter(w));
	        }
	        return res;
	      }, []).join(' ');
	    },
	    getElementOffset(el) {
	      let box = el.getBoundingClientRect();
	      let docElem = document.documentElement;
	      return {
	        top: box.top + window.scrollY - docElem.clientTop,
	        left: box.left + window.scrollX - docElem.clientLeft
	      };
	    },
	    memoize(func) {
	      let cache = new Map();
	      return function (...args) {
	        let key = JSON.stringify(args);
	        if (!cache.has(key)) {
	          cache.set(key, func.apply(this, args));
	        }
	        return cache.get(key);
	      };
	    },
	    pluralize(singular, countOrPlural, countOrUndefined) {
	      let count = countOrUndefined ?? countOrPlural;
	      let plural = countOrUndefined ? countOrPlural : singular + 's';
	      return count === 1 ? singular : plural;
	    }
	  };
	});
	_.screenType;
	_.isTabletScreen;
	_.isMobileScreen;
	_.calculateGrowth;
	_.getValueFormatter;
	_.flattenFiles;
	_.formatDate;
	_.formatDateTime;
	_.formatHits;
	_.formatNumber;
	_.formatNumberWithSpace;
	_.getMinifiedName;
	_.getNonMinifiedName;
	_.listFiles;
	_.nth;
	_.getChartXAxisData;
	_.unescapeHtml;
	_.getValueByMagnitude;
	_.convertBytesToUnits;
	_.findUnitFromArray;
	_.findUnitFromNumber;
	_.formatBytesWithUnit;
	_.formatGrowth;
	_.formatShare;
	_.formatToShortNumber;
	_.makeHTTPRequest;
	_.createQueryString;
	_.deepExtend;
	_.onDocumentReady;
	_.checkIfYearIsLeap;
	_.getAmountOfDaysByMonth;
	_.getDateFormats;
	_.prepareDataForChartGroupedBy;
	_.createWeekPeriodChartLabels;
	_.createMonthPeriodChartLabels;
	_.createYearPeriodChartLabels;
	_.getSortedIterableChartData;
	_.getPreparedDataForBarChart;
	_.calcChartBarThicknessByResolution;
	_.getPreparedProvidersDataForLineChart;
	_.getPreparedDataForLineChart;
	_.createImprovedExternalTooltipTitle;
	_.translatePeriodsToSNotation;
	_.optimizeSrc;
	_.normalizeHref;
	_.isExternalLink;
	_.packageToImportName;
	_.filterListStatPeriods;
	_.prepareFilteredStatPeriods;
	_.getPreparedListStatPeriods;
	_.truncate;
	_.capitalizeFirstLetter;
	_.capitalizeStrEveryFirstLetter;
	_.getElementOffset;
	_.memoize;
	_.pluralize;

	var component$6 = {
	  exports: {}
	};
	component$6.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "div",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-header-gradient",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "img",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-gradient_primary",
	        g: 1
	      }, {
	        n: "fetchpriority",
	        f: "high",
	        t: 13,
	        g: 1
	      }, {
	        n: "width",
	        f: "1440",
	        t: 13,
	        g: 1
	      }, {
	        n: "height",
	        f: "684",
	        t: 13,
	        g: 1
	      }, {
	        n: "src",
	        f: [{
	          t: 2,
	          r: "@shared.assetsHost"
	        }, "/img/about/about-gradient.jpg"],
	        t: 13
	      }]
	    }, " ", {
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "header-gradient_secondary",
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "header-gradient_map",
	          g: 1
	        }]
	      }],
	      n: 50,
	      r: "showMap"
	    }]
	  }]
	};
	var headerGradient = ractive__default["default"].extend(component$6.exports);

	var has = {
	  localStorage() {
	    try {
	      localStorage.setItem('localStorageTest', 1);
	      localStorage.removeItem('localStorageTest');
	    } catch {
	      return false;
	    }
	    return true;
	  },
	  sessionStorage() {
	    try {
	      sessionStorage.setItem('sessionStorageTest', 1);
	      sessionStorage.removeItem('sessionStorageTest');
	    } catch {
	      return false;
	    }
	    return true;
	  }
	};

	var component$5 = {
	  exports: {}
	};
	const notificationKey = 'job-1-notificationSeen';
	component$5.exports = {
	  data() {
	    return {
	      notificationSeen: true
	    };
	  },
	  oninit() {
	    if (ractive__default["default"].isServer) {
	      this.set('notificationSeen', true);
	    } else {
	      if (has.localStorage()) {
	        if (localStorage.getItem(notificationKey)) {
	          this.set('notificationSeen', true);
	        }
	        this.observe('notificationSeen', newValue => {
	          localStorage.setItem(notificationKey, JSON.stringify(newValue));
	        }, {
	          init: false
	        });
	      }

	      // this.observe('notificationSeen', (newValue) => {
	      // 	document.body.classList[newValue ? 'remove' : 'add']('c-notification-visible');
	      // });
	    }
	  }
	};
	component$5.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "c-notification",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "i",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "fa fa-bullhorn",
	          g: 1
	        }, {
	          n: "aria-hidden",
	          f: "true",
	          t: 13,
	          g: 1
	        }]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: "href",
	          f: "https://gist.github.com/jimaek/de24cee25048de8bbe3f0d811695cdf7",
	          t: 13,
	          g: 1
	        }, {
	          n: "target",
	          f: "_blank",
	          t: 13,
	          g: 1
	        }],
	        f: ["We're looking for a Senior Node.js Engineer to help expand our open-source projects!"]
	      }, " ", {
	        t: 7,
	        e: "a",
	        m: [{
	          n: ["click"],
	          t: 70,
	          f: {
	            r: ["@this"],
	            s: "[_0.set(\"notificationSeen\",true)]"
	          }
	        }, {
	          n: "aria-label",
	          f: "Close",
	          t: 13,
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "i",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "fa fa-times",
	            g: 1
	          }, {
	            n: "aria-hidden",
	            f: "true",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 50,
	    x: {
	      r: ["notificationSeen"],
	      s: "!_0"
	    }
	  }],
	  e: {
	    "[_0.set(\"notificationSeen\",true)]": function (_0) {
	      return [_0.set("notificationSeen", true)];
	    },
	    "!_0": function (_0) {
	      return !_0;
	    }
	  }
	};
	var notification = ractive__default["default"].extend(component$5.exports);

	const API_HOST = 'https://data.jsdelivr.com';
	const GITHUB_API_HOST = 'https://api.github.com';
	const SNYK_API_HOST = 'https://snyk-widget.herokuapp.com';
	const RAW_GH_USER_CONTENT_HOST = 'https://raw.githubusercontent.com';
	const HTTP_CACHE = new Map();
	const getWithCache = (url, params = {}, responseHeadersToGet = null) => {
	  url += _.createQueryString(params);
	  if (HTTP_CACHE.has(url)) {
	    return HTTP_CACHE.get(url);
	  }
	  let request;
	  if (responseHeadersToGet) {
	    request = _.makeHTTPRequest({
	      url,
	      responseHeadersToGet
	    });
	  } else {
	    request = _.makeHTTPRequest({
	      url
	    });
	  }
	  HTTP_CACHE.set(url, request);
	  return request;
	};
	var fetchPackageReadme = (type, name, version) => {
	  return _.makeHTTPRequest({
	    url: `/readme/${type}/${name}${version ? `/${version}` : ''}`,
	    rawResponse: true
	  });
	};
	var fetchNetworkStats = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/network/content?period=${period}`);
	};
	var fetchPackageFiles = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`);
	};
	var fetchPackageFilesFlat = (type, name, version) => {
	  let flatten = items => {
	    return items.reduce((acc, item) => {
	      if (item.type === 'file') {
	        acc.push({
	          ...item,
	          name: `/${item.name}`
	        });
	        return acc;
	      }
	      return flatten(item.files).reduce((acc, file) => {
	        acc.push({
	          ...file,
	          name: `/${item.name}${file.name}`
	        });
	        return acc;
	      }, acc);
	    }, []);
	  };
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}`).then(response => {
	    return {
	      ...response,
	      files: flatten(response.files)
	    };
	  });
	};
	var fetchPackageFileStats = (type, name, version, period = 'month', by = 'hits', limit = undefined) => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageFileStatsWithHeaders = (type, name, version, period = 'month', by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}@${encodeURIComponent(version)}/files`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageSummaryStats = (type, name, period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}`, {
	    period
	  });
	};
	var fetchPackageVersionsStats = (type, name, period = 'month', by = 'hits', limit = '5') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit
	  });
	};
	var fetchPackageVersionsStatsWithHeaders = (type, name, period = 'month', by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/packages/${type}/${name}/versions`, {
	    period,
	    by,
	    limit,
	    page
	  }, responseHeadersToGet);
	};
	var fetchPackageVersions = (type, name) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}`);
	};
	var fetchTopPackages = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/packages?type=npm&period=${period}`);
	};
	var fetchProjectCommits = (owner, repo) => {
	  return getWithCache(`${GITHUB_API_HOST}/repos/${owner}/${repo}/commits`);
	};
	var findProjectIssue = (owner, repo, title) => {
	  return getWithCache(`${GITHUB_API_HOST}/search/issues`, {
	    q: `${title} user:${owner} repo:${repo}`
	  });
	};
	var fetchPackageVulnerabilities = (name, version) => {
	  return _.makeHTTPRequest({
	    url: `${SNYK_API_HOST}/test/npm/lib/${name}/${version}`,
	    headers: {
	      Authorization: '8U@$Kh6Qs#b@9qxYB!QhtvLeD=e+?Hq$_b#5%x*t'
	    }
	  });
	};
	var fetchPackageEntrypoints = (type, name, version) => {
	  return getWithCache(`${API_HOST}/v1/packages/${type}/${name}@${encodeURIComponent(version)}/entrypoints`);
	};
	var getGHUserContentPackageReadme = (packageOwner, packageName, packageGitHead = 'HEAD') => {
	  return new Promise((resolve, reject) => {
	    _.makeHTTPRequest({
	      url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.md`,
	      rawResponse: true
	    }).then(response => {
	      resolve(response);
	    }).catch(() => {
	      _.makeHTTPRequest({
	        url: `${RAW_GH_USER_CONTENT_HOST}/${packageOwner}/${packageName}/${packageGitHead}/README.markdown`,
	        rawResponse: true
	      }).then(response => {
	        resolve(response);
	      }).catch(err => {
	        reject(err);
	      });
	    });
	  });
	};
	var fetchCdnOssStats = (name, period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}`, {
	    period
	  });
	};
	var fetchNetworkProviderStats = (period, country = '', continent = '') => {
	  let body = {
	    period
	  };
	  country && (body.country = country);
	  continent && (body.continent = continent);
	  return getWithCache(`${API_HOST}/v1/stats/network`, body);
	};
	var fetchNetworkProviderStatsByCountry = (period = 'month') => {
	  return getWithCache(`${API_HOST}/v1/stats/network/countries`, {
	    period
	  });
	};

	/** *
	 * @param dataType - request type value: "platforms", "browsers"
	 * @param isVersionGrouped  - version grouped switchbox value: boolean
	 * @param selectedItem - selected certain platform or browser value:string
	 * @param breakdown - country breakdown, browser breakdown, platform, version breakdown
	 * @param period -  time period for which the stats are returned (s-month, s-year)
	 * @param country - country. Includes only data for this country
	 * @param continent - continent. Includes only data for this country
	 ***/
	var fetchTopPlatformBrowserStats = (dataType, isVersionGrouped, period, selectedItem, breakdown, country, continent, page = 1, limit = 10) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let url = dataType === 'platform' ? `${API_HOST}/v1/stats/platforms` : `${API_HOST}/v1/stats/browsers`;
	  let body = {
	    period: _.translatePeriodsToSNotation(period),
	    page,
	    limit
	  };
	  if (country) {
	    body.country = country;
	  }
	  if (continent) {
	    body.continent = continent;
	  }
	  if (selectedItem) {
	    if (selectedItem.version) {
	      url += `/${selectedItem.name.toLowerCase()}/versions/${selectedItem.version}/countries`;
	    } else {
	      url += `/${selectedItem.name.toLowerCase()}/${breakdown}`;
	    }
	  } else if (!isVersionGrouped) {
	    url += '/versions';
	  }
	  return _.makeHTTPRequest({
	    url,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchProjectStats = (type, period, sortBy = 'hits', page = 1, limit = 10) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  let body = {
	    period,
	    by: sortBy,
	    page,
	    limit
	  };
	  if (type !== 'all') {
	    body.type = type;
	  }
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchNetworkWideStats = () => {
	  return getWithCache(`${API_HOST}/v1/stats/network`);
	};
	var fetchNumberOfResources = () => {
	  let responseHeadersToGet = ['x-total-count'];
	  let body = {
	    limit: 1
	  };
	  return _.makeHTTPRequest({
	    url: `${API_HOST}/v1/stats/packages`,
	    body,
	    responseHeadersToGet
	  });
	};
	var fetchListStatPeriods = () => {
	  return getWithCache(`${API_HOST}/v1/stats/periods`);
	};
	var getBlogRss = () => {
	  return _.makeHTTPRequest({
	    url: `/blog/rss`,
	    rawResponse: true
	  });
	};
	var getCdnOssFiles = (name, by = 'hits', limit = 5, page = 1) => {
	  let responseHeadersToGet = ['x-total-count', 'x-total-pages'];
	  return getWithCache(`${API_HOST}/v1/stats/proxies/${name}/files`, {
	    page,
	    limit,
	    by
	  }, responseHeadersToGet);
	};
	var http = {
	  fetchPackageReadme: fetchPackageReadme,
	  fetchNetworkStats: fetchNetworkStats,
	  fetchPackageFiles: fetchPackageFiles,
	  fetchPackageFilesFlat: fetchPackageFilesFlat,
	  fetchPackageFileStats: fetchPackageFileStats,
	  fetchPackageFileStatsWithHeaders: fetchPackageFileStatsWithHeaders,
	  fetchPackageSummaryStats: fetchPackageSummaryStats,
	  fetchPackageVersionsStats: fetchPackageVersionsStats,
	  fetchPackageVersionsStatsWithHeaders: fetchPackageVersionsStatsWithHeaders,
	  fetchPackageVersions: fetchPackageVersions,
	  fetchTopPackages: fetchTopPackages,
	  fetchProjectCommits: fetchProjectCommits,
	  findProjectIssue: findProjectIssue,
	  fetchPackageVulnerabilities: fetchPackageVulnerabilities,
	  fetchPackageEntrypoints: fetchPackageEntrypoints,
	  getGHUserContentPackageReadme: getGHUserContentPackageReadme,
	  fetchCdnOssStats: fetchCdnOssStats,
	  fetchNetworkProviderStats: fetchNetworkProviderStats,
	  fetchNetworkProviderStatsByCountry: fetchNetworkProviderStatsByCountry,
	  fetchTopPlatformBrowserStats: fetchTopPlatformBrowserStats,
	  fetchProjectStats: fetchProjectStats,
	  fetchNetworkWideStats: fetchNetworkWideStats,
	  fetchNumberOfResources: fetchNumberOfResources,
	  fetchListStatPeriods: fetchListStatPeriods,
	  getBlogRss: getBlogRss,
	  getCdnOssFiles: getCdnOssFiles
	};

	var component$4 = {
	  exports: {}
	};
	component$4.exports = {
	  data() {
	    return {
	      date: new Date(),
	      docInnerHtml: null,
	      blogLinksData: null
	    };
	  },
	  oninit() {
	    if (!ractive__default["default"].isServer) {
	      http.getBlogRss().then(response => {
	        if (response) {
	          let document = new window.DOMParser().parseFromString(response, 'text/xml');
	          let items = document.documentElement.childNodes[0].getElementsByTagName('item');
	          let data = [];
	          for (let i = 0; i < items.length; i++) {
	            let currItemNodesList = items[i].childNodes;
	            let currItemTitle;
	            let currItemLink;
	            let currItemPubDate;
	            for (let k = 0; k < currItemNodesList.length; k++) {
	              if (currItemNodesList[k].nodeName === 'title') {
	                currItemTitle = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'link') {
	                currItemLink = currItemNodesList[k].textContent;
	              } else if (currItemNodesList[k].nodeName === 'pubDate') {
	                currItemPubDate = currItemNodesList[k].textContent;
	              }
	            }
	            data.push({
	              text: currItemTitle,
	              url: new URL(currItemLink, 'https://www.jsdelivr.com').pathname,
	              date: new Date(currItemPubDate).getTime()
	            });
	          }
	          data.sort((a, b) => b.date - a.date);
	          this.set('blogLinksData', data.slice(0, 5));
	        }
	      });
	    }
	  }
	};
	component$4.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "footer",
	    m: [{
	      t: 13,
	      n: "class",
	      f: "c-footer",
	      g: 1
	    }],
	    f: [{
	      t: 7,
	      e: "div",
	      m: [{
	        t: 13,
	        n: "class",
	        f: "wrapper",
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "row block-main",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-6 main-left",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "maintain-header",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14 op-64",
	                  g: 1
	                }],
	                f: ["Maintained by"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14",
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/about#people",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["jsDelivr team and contributors"]
	              }, " ", {
	                t: 7,
	                e: "br"
	              }, " ", {
	                t: 7,
	                e: "span",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14 op-64",
	                  g: 1
	                }],
	                f: ["Founded by"]
	              }, " ", {
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "text-footer-14",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://dakulov.com/",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Dmitriy Akulov"]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "col-xs-12 col-sm-6 main-right",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "main-right-container",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "subscribe-header",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "text-footer-14",
	                    g: 1
	                  }],
	                  f: ["Sign up to our newsletter"]
	                }]
	              }, " ", {
	                t: 7,
	                e: "form",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "form-inline subscribe-content",
	                  g: 1
	                }, {
	                  n: "action",
	                  f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "method",
	                  f: "POST",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "div",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "form-group",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "input",
	                    m: [{
	                      n: "type",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "autocomplete",
	                      f: "email",
	                      t: 13
	                    }, {
	                      n: "class",
	                      f: "form-control",
	                      t: 13
	                    }, {
	                      n: "name",
	                      f: "MERGE0",
	                      t: 13
	                    }, {
	                      n: "id",
	                      f: "new-email",
	                      t: 13
	                    }, {
	                      n: "placeholder",
	                      f: "Enter your e-mail",
	                      t: 13
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "button",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "btn btn-default semi-bold",
	                    g: 1
	                  }, {
	                    n: "type",
	                    f: "submit",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: ["Subscribe"]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "block-list",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "title-copy-bottom op-64",
	              g: 1
	            }],
	            f: ["© jsdelivr.com, 2012 - ", {
	              t: 2,
	              x: {
	                r: ["date"],
	                s: "_0.getFullYear()"
	              }
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "row list-primary",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "col-sm-12",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-copy op-64",
	                  g: 1
	                }],
	                f: ["© jsdelivr.com, 2012 - ", {
	                  t: 2,
	                  x: {
	                    r: ["date"],
	                    s: "_0.getFullYear()"
	                  }
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/about",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["About"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/history",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Our History"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/sponsors",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Our Sponsors"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/oss-cdn",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Custom OSS CDN"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "https://status.jsdelivr.com/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Status"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/terms",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Terms & Policies"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "mailto:d@jsdelivr.com",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["d@jsdelivr.com"]
	                  }]
	                }]
	              }]
	            }]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "row list-second",
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "div",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "col-sm-12",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "div",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "title-convert op-64",
	                  g: 1
	                }],
	                f: ["Convert from:"]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/github",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/google",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Google Hosted Libraries"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/unpkg",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["unpkg"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/skypack",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Skypack"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esmsh",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.sh"]
	                  }]
	                }]
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-separator",
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "footer-blog-links",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_title op-64",
	              g: 1
	            }],
	            f: ["From our Blog"]
	          }, " ", {
	            t: 7,
	            e: "div",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "footer-blog-links_block",
	              g: 1
	            }],
	            f: [{
	              t: 4,
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "router-ignore",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: [{
	                    t: 2,
	                    r: "@shared.serverHost"
	                  }, {
	                    t: 2,
	                    r: "./url"
	                  }],
	                  t: 13
	                }],
	                f: [{
	                  t: 2,
	                  r: "./text"
	                }]
	              }],
	              n: 52,
	              r: "blogLinksData"
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "_0.getFullYear()": function (_0) {
	      return _0.getFullYear();
	    }
	  }
	};
	var footer = ractive__default["default"].extend(component$4.exports);

	var component$3 = {
	  exports: {}
	};
	component$3.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "header",
	    m: [{
	      n: "class",
	      f: ["c-header ", {
	        t: 4,
	        f: ["disabled"],
	        n: 50,
	        r: "searchOpened"
	      }, " ", {
	        t: 4,
	        f: [{
	          t: 2,
	          r: "additionalClasses"
	        }],
	        n: 50,
	        r: "additionalClasses"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "nav",
	      m: [{
	        n: "class",
	        f: ["navbar navbar-default ", {
	          t: 2,
	          x: {
	            r: ["@shared.actualPath", "useWhiteLogos"],
	            s: "!_0||_1?\"navbar-filled\":\"\""
	          }
	        }],
	        t: 13
	      }],
	      f: [{
	        t: 7,
	        e: "div",
	        m: [{
	          t: 13,
	          n: "class",
	          f: "container-fluid container-mw",
	          g: 1
	        }],
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "navbar-header",
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "a",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "main-logo",
	              g: 1
	            }, {
	              n: "href",
	              f: "/",
	              t: 13,
	              g: 1
	            }, {
	              n: ["click"],
	              t: 70,
	              f: {
	                r: ["@this"],
	                s: "[_0.fire(\"main-logo-click\")]"
	              }
	            }],
	            f: [{
	              t: 9,
	              c: "\n\t\t\t\t\t\tLooking for the logo?\n\t\t\t\t\t\tGet all versions here: https://github.com/jsdelivr/jsdelivr-media\n\t\t\t\t\t"
	            }, " ", {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "29",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "32",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/icons/jsdelivr_icon.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath"],
	                s: "_0&&_0.startsWith(\"/package/\")"
	              }
	            }, {
	              t: 4,
	              f: [{
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-white.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }, " "],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath"],
	                s: "_0&&_0.startsWith(\"/docs/data.jsdelivr.com\")"
	              },
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-full-white.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }, " "],
	              n: 50,
	              x: {
	                r: ["@shared.actualPath", "useWhiteLogos"],
	                s: "_0&&_1"
	              },
	              l: 1
	            }, {
	              t: 4,
	              f: [" ", {
	                t: 7,
	                e: "img",
	                m: [{
	                  n: "width",
	                  f: "140",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "height",
	                  f: "34",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "src",
	                  f: [{
	                    t: 2,
	                    r: "@shared.assetsHost"
	                  }, "/img/jsdelivr-horizontal-regular.svg"],
	                  t: 13
	                }, {
	                  n: "title",
	                  f: "jsDelivr",
	                  t: 13,
	                  g: 1
	                }]
	              }],
	              n: 50,
	              r: "@shared.actualPath",
	              l: 1
	            }]
	          }, " ", {
	            t: 4,
	            f: [{
	              t: 16
	            }],
	            n: 50,
	            x: {
	              r: ["@shared.actualPath"],
	              s: "_0&&_0.includes(\"/package/\")"
	            }
	          }, " ", {
	            t: 7,
	            e: "button",
	            m: [{
	              t: 13,
	              n: "class",
	              f: "navbar-toggle collapsed",
	              g: 1
	            }, {
	              n: "type",
	              f: "button",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-toggle",
	              f: "collapse",
	              t: 13,
	              g: 1
	            }, {
	              n: "data-target",
	              f: "#main-navbar",
	              t: 13,
	              g: 1
	            }, {
	              n: "aria-expanded",
	              f: "false",
	              t: 13,
	              g: 1
	            }],
	            f: [{
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "sr-only",
	                g: 1
	              }],
	              f: ["Toggle navigation"]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }, " ", {
	              t: 7,
	              e: "span",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "icon-bar",
	                g: 1
	              }]
	            }]
	          }]
	        }, " ", {
	          t: 7,
	          e: "div",
	          m: [{
	            t: 13,
	            n: "class",
	            f: "collapse navbar-collapse",
	            g: 1
	          }, {
	            n: "id",
	            f: "main-navbar",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 7,
	            e: "ul",
	            m: [{
	              n: "class",
	              f: ["nav navbar-nav navbar-right ", {
	                t: 2,
	                x: {
	                  r: ["@shared.actualPath", "useWhiteLogos"],
	                  s: "!_0?\"navbar-hidden\":_1?\"about-navbar-right\":\"default-navbar-right\""
	                }
	              }],
	              t: 13
	            }],
	            f: [{
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/about",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["About Us"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/network",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Network"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/statistics",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Stats"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "/sponsors",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Sponsors"]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Tools ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/tools/purge",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Purge cache"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "divider",
	                    g: 1
	                  }, {
	                    n: "role",
	                    f: "separator",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-header",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: ["Convert from"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/github",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["GitHub"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/google",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Google Hosted Libraries"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/unpkg",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["unpkg"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/skypack",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Skypack"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esmsh",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.sh"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              m: [{
	                t: 13,
	                n: "class",
	                f: "dropdown",
	                g: 1
	              }],
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-toggle",
	                  g: 1
	                }, {
	                  n: "data-toggle",
	                  f: "dropdown",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "role",
	                  f: "button",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-haspopup",
	                  f: "true",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "aria-expanded",
	                  f: "false",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Resources ", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-angle-down",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }]
	              }, " ", {
	                t: 7,
	                e: "ul",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "dropdown-menu",
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "/blog/",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Blog ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "target",
	                      f: "_blank",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "rel",
	                      f: "noopener noreferrer",
	                      t: 13,
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "https://jsdelivr.us11.list-manage.com/subscribe?u=0c85fe2c9a60310df9a3d6751&id=283887f736",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Newsletter ", {
	                      t: 7,
	                      e: "i",
	                      m: [{
	                        t: 13,
	                        n: "class",
	                        f: "fa fa-external-link",
	                        g: 1
	                      }, {
	                        n: "aria-hidden",
	                        f: "true",
	                        t: 13,
	                        g: 1
	                      }]
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/esm",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["esm.run"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "dropdown-header",
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "div",
	                    f: ["Documentation"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      n: "href",
	                      f: "/documentation",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Open Source CDN"]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "li",
	                  f: [{
	                    t: 7,
	                    e: "a",
	                    m: [{
	                      t: 13,
	                      n: "class",
	                      f: "router-ignore",
	                      g: 1
	                    }, {
	                      n: "href",
	                      f: "/docs/data.jsdelivr.com",
	                      t: 13,
	                      g: 1
	                    }],
	                    f: ["Public API"]
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "href",
	                  f: "https://globalping.io",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }],
	                f: ["Globalping", {
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-external-link",
	                    g: 1
	                  }]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://github.com/jsdelivr/jsdelivr",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "GitHub",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-github",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["GitHub"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "https://twitter.com/jsDelivr",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Twitter",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "i",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "fa fa-twitter",
	                    g: 1
	                  }, {
	                    n: "aria-hidden",
	                    f: "true",
	                    t: 13,
	                    g: 1
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["Twitter"]
	                }]
	              }]
	            }, " ", {
	              t: 7,
	              e: "li",
	              f: [{
	                t: 7,
	                e: "a",
	                m: [{
	                  t: 13,
	                  n: "class",
	                  f: "router-ignore",
	                  g: 1
	                }, {
	                  n: "target",
	                  f: "_blank",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "rel",
	                  f: "noopener noreferrer",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "href",
	                  f: "/discord",
	                  t: 13,
	                  g: 1
	                }, {
	                  n: "title",
	                  f: "Discord",
	                  t: 13,
	                  g: 1
	                }],
	                f: [{
	                  t: 7,
	                  e: "svg",
	                  m: [{
	                    t: 13,
	                    n: "style",
	                    f: "margin-top: 1px;",
	                    g: 1
	                  }, {
	                    t: 13,
	                    n: "class",
	                    f: "fa",
	                    g: 1
	                  }, {
	                    n: "xmlns",
	                    f: "http://www.w3.org/2000/svg",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "viewBox",
	                    f: "0 0 640 512",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "width",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "height",
	                    f: "14",
	                    t: 13,
	                    g: 1
	                  }, {
	                    n: "title",
	                    f: "Discord",
	                    t: 13,
	                    g: 1
	                  }],
	                  f: [{
	                    t: 7,
	                    e: "path",
	                    m: [{
	                      n: "fill",
	                      f: [{
	                        t: 4,
	                        f: ["#fff"],
	                        n: 50,
	                        r: "useWhiteLogos"
	                      }, {
	                        t: 4,
	                        f: ["#17233b"],
	                        n: 51,
	                        l: 1
	                      }],
	                      t: 13
	                    }, {
	                      n: "d",
	                      f: "M524.531 69.836a1.5 1.5 0 0 0-.764-.7A485.065 485.065 0 0 0 404.081 32.03a1.816 1.816 0 0 0-1.923.91 337.461 337.461 0 0 0-14.9 30.6 447.848 447.848 0 0 0-134.426 0 309.541 309.541 0 0 0-15.135-30.6 1.89 1.89 0 0 0-1.924-.91 483.689 483.689 0 0 0-119.688 37.107 1.712 1.712 0 0 0-.788.676C39.068 183.651 18.186 294.69 28.43 404.354a2.016 2.016 0 0 0 .765 1.375 487.666 487.666 0 0 0 146.825 74.189 1.9 1.9 0 0 0 2.063-.676A348.2 348.2 0 0 0 208.12 430.4a1.86 1.86 0 0 0-1.019-2.588 321.173 321.173 0 0 1-45.868-21.853 1.885 1.885 0 0 1-.185-3.126 251.047 251.047 0 0 0 9.109-7.137 1.819 1.819 0 0 1 1.9-.256c96.229 43.917 200.41 43.917 295.5 0a1.812 1.812 0 0 1 1.924.233 234.533 234.533 0 0 0 9.132 7.16 1.884 1.884 0 0 1-.162 3.126 301.407 301.407 0 0 1-45.89 21.83 1.875 1.875 0 0 0-1 2.611 391.055 391.055 0 0 0 30.014 48.815 1.864 1.864 0 0 0 2.063.7A486.048 486.048 0 0 0 610.7 405.729a1.882 1.882 0 0 0 .765-1.352c12.264-126.783-20.532-236.912-86.934-334.541ZM222.491 337.58c-28.972 0-52.844-26.587-52.844-59.239s23.409-59.241 52.844-59.241c29.665 0 53.306 26.82 52.843 59.239 0 32.654-23.41 59.241-52.843 59.241Zm195.38 0c-28.971 0-52.843-26.587-52.843-59.239s23.409-59.241 52.843-59.241c29.667 0 53.307 26.82 52.844 59.239 0 32.654-23.177 59.241-52.844 59.241Z",
	                      t: 13,
	                      g: 1
	                    }]
	                  }]
	                }, " ", {
	                  t: 7,
	                  e: "span",
	                  m: [{
	                    t: 13,
	                    n: "class",
	                    f: "icon-label-mobile",
	                    g: 1
	                  }],
	                  f: ["Discord"]
	                }]
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  }],
	  e: {
	    "!_0||_1?\"navbar-filled\":\"\"": function (_0, _1) {
	      return !_0 || _1 ? "navbar-filled" : "";
	    },
	    "[_0.fire(\"main-logo-click\")]": function (_0) {
	      return [_0.fire("main-logo-click")];
	    },
	    "_0&&_0.startsWith(\"/package/\")": function (_0) {
	      return _0 && _0.startsWith("/package/");
	    },
	    "_0&&_0.startsWith(\"/docs/data.jsdelivr.com\")": function (_0) {
	      return _0 && _0.startsWith("/docs/data.jsdelivr.com");
	    },
	    "_0&&_1": function (_0, _1) {
	      return _0 && _1;
	    },
	    "_0&&_0.includes(\"/package/\")": function (_0) {
	      return _0 && _0.includes("/package/");
	    },
	    "!_0?\"navbar-hidden\":_1?\"about-navbar-right\":\"default-navbar-right\"": function (_0, _1) {
	      return !_0 ? "navbar-hidden" : _1 ? "about-navbar-right" : "default-navbar-right";
	    }
	  }
	};
	var header = ractive__default["default"].extend(component$3.exports);

	var component$2 = {
	  exports: {}
	};
	component$2.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-data",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t<<RACTIVE_SERIALIZED_DATA>>\n\t"]
	    }, " ", {
	      t: 7,
	      e: "script",
	      m: [{
	        n: "type",
	        f: "text/plain",
	        t: 13,
	        g: 1
	      }, {
	        n: "id",
	        f: "ractive-shared",
	        t: 13,
	        g: 1
	      }],
	      f: ["\t\t", {
	        t: 2,
	        x: {
	          r: ["@shared", "@shared.serverHost", "@shared.assetsHost", "@shared.apiDocsHost", "@shared.assetsVersion", "@shared.route", "@shared.params", "@shared.qsParams", "@shared.options"],
	          s: "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))"
	        }
	      }, "\n\t"]
	    }],
	    n: 50,
	    r: "@shared.isServer"
	  }],
	  e: {
	    "_0.escape(JSON.stringify({serverHost:_1,assetsHost:_2,apiDocsHost:_3,assetsVersion:_4,route:_5,params:_6,qsParams:_7,options:_8}))": function (_0, _1, _2, _3, _4, _5, _6, _7, _8) {
	      return _0.escape(JSON.stringify({
	        serverHost: _1,
	        assetsHost: _2,
	        apiDocsHost: _3,
	        assetsVersion: _4,
	        route: _5,
	        params: _6,
	        qsParams: _7,
	        options: _8
	      }));
	    }
	  }
	};
	var rSerialize = ractive__default["default"].extend(component$2.exports);

	var component$1 = {
	  exports: {}
	};
	component$1.exports = {
	  data() {
	    return {
	      publicRoot: ''
	    };
	  }
	};
	component$1.exports.template = {
	  v: 4,
	  t: [{
	    t: 4,
	    f: [{
	      t: 16
	    }],
	    n: 50,
	    x: {
	      r: ["@shared.isServer"],
	      s: "!_0"
	    }
	  }, {
	    t: 4,
	    f: [{
	      t: 18,
	      a: " html"
	    }, " ", {
	      t: 7,
	      e: "html",
	      m: [{
	        n: "lang",
	        f: "en",
	        t: 13,
	        g: 1
	      }],
	      f: [{
	        t: 7,
	        e: "head",
	        f: [{
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "charset",
	            f: "utf-8",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "viewport",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "width=device-width, initial-scale=1",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "description",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              x: {
	                r: ["description"],
	                s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	              }
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "keywords",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "jsdelivr, cdn, npm, github, js, javascript, free, open source, oss, deno, wordpress",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:locale",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "en_US",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:type",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "website",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:title",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              x: {
	                r: ["title"],
	                s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\""
	              }
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:description",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              x: {
	                r: ["description"],
	                s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	              }
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:url",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              r: "@shared.serverHost"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "property",
	            f: "og:site_name",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "jsDelivr",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "openGraphImage"
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:secure_url",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "openGraphImage"
	              }],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:width",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: "1280",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:height",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: "640",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "name",
	              f: "twitter:image",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "openGraphImage"
	              }],
	              t: 13
	            }]
	          }],
	          n: 50,
	          r: "openGraphImage"
	        }, {
	          t: 4,
	          f: [{
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/og-jsdelivr-api.png"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:secure_url",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/og-jsdelivr-api.png"],
	              t: 13
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:width",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: "1280",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "property",
	              f: "og:image:height",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: "640",
	              t: 13,
	              g: 1
	            }]
	          }, " ", {
	            t: 7,
	            e: "meta",
	            m: [{
	              n: "name",
	              f: "twitter:image",
	              t: 13,
	              g: 1
	            }, {
	              n: "content",
	              f: [{
	                t: 2,
	                r: "@shared.assetsHost"
	              }, "/img/og-jsdelivr-api.png"],
	              t: 13
	            }]
	          }],
	          n: 51,
	          l: 1
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "twitter:card",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "summary_large_image",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "twitter:description",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              x: {
	                r: ["description"],
	                s: "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\""
	              }
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "twitter:title",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              x: {
	                r: ["title"],
	                s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\""
	              }
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "twitter:site",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "@jsdelivr",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "twitter:creator",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "@jsdelivr",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "title",
	          f: [{
	            t: 2,
	            x: {
	              r: ["title"],
	              s: "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\""
	            }
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "image/x-icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/favicon.ico"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "image/svg+xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/favicon.svg"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "image/png",
	            t: 13,
	            g: 1
	          }, {
	            n: "sizes",
	            f: "48x48",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/favicon-48x48.png"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "image/png",
	            t: 13,
	            g: 1
	          }, {
	            n: "sizes",
	            f: "32x32",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/favicon-32x32.png"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "image/png",
	            t: 13,
	            g: 1
	          }, {
	            n: "sizes",
	            f: "16x16",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/favicon-16x16.png"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "apple-touch-icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "sizes",
	            f: "180x180",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/apple-touch-icon.png"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "manifest",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/site.webmanifest"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "mask-icon",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/safari-pinned-tab.svg"],
	            t: 13
	          }, {
	            n: "color",
	            f: "#e64e3d",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "msapplication-TileColor",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "#ffffff",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "msapplication-config",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: [{
	              t: 2,
	              r: "publicRoot"
	            }, "/icons/browserconfig.xml"],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "meta",
	          m: [{
	            n: "name",
	            f: "theme-color",
	            t: 13,
	            g: 1
	          }, {
	            n: "content",
	            f: "#ffffff",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 16,
	          r: "seo"
	        }, " ", {
	          t: 9,
	          c: " Maybe will be useful in Firefox at some point. "
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://data.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "dns-prefetch",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://datum.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://data.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "preconnect",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://datum.jsdelivr.com/",
	            t: 13,
	            g: 1
	          }, {
	            n: "crossorigin",
	            f: "anonymous",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/css/app.css?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "stylesheet",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "https://cdn.jsdelivr.net/npm/font-awesome@4.7.0/css/font-awesome.min.css",
	            t: 13,
	            g: 1
	          }, {
	            n: "media",
	            f: "print",
	            t: 13,
	            g: 1
	          }, {
	            n: "onload",
	            f: "this.media='all'",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "sitemap",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/sitemap/index.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/xml",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "link",
	          m: [{
	            n: "rel",
	            f: "search",
	            t: 13,
	            g: 1
	          }, {
	            n: "href",
	            f: "/opensearch.xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "type",
	            f: "application/opensearchdescription+xml",
	            t: 13,
	            g: 1
	          }, {
	            n: "title",
	            f: "jsDelivr",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "style",
	          f: ["\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Lexend';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 100 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/lexend:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\n\t\t\t\t@font-face {\n\t\t\t\t\tfont-family: 'Source Code Pro';\n\t\t\t\t\tfont-style: normal;\n\t\t\t\t\tfont-weight: 200 900;\n\t\t\t\t\tsrc: url(https://cdn.jsdelivr.net/fontsource/fonts/source-code-pro:vf@latest/latin-wght-normal.woff2) format('woff2-variations');\n\t\t\t\t}\n\t\t\t"]
	        }, " ", {
	          t: 16,
	          r: "css"
	        }]
	      }, " ", {
	        t: 7,
	        e: "body",
	        f: [{
	          t: 7,
	          e: "div",
	          m: [{
	            n: "id",
	            f: "page",
	            t: 13,
	            g: 1
	          }],
	          f: [{
	            t: 4,
	            f: [{
	              t: 16
	            }],
	            n: 51,
	            r: "noYield"
	          }]
	        }, " ", {
	          t: 7,
	          e: "r-serialize"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive@1.4.0/runtime.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/ractive-route@0.3.11/ractive-route.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/jquery@3.6.3/dist/jquery.slim.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: "https://cdn.jsdelivr.net/npm/bootstrap@3.3.7/dist/js/bootstrap.min.js",
	            t: 13,
	            g: 1
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: ["https://cdn.jsdelivr.net/gh/MartinKolarik/RapiDoc@customized/dist/rapidoc-min.js?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 16,
	          r: "js"
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "src",
	            f: [{
	              t: 2,
	              r: "@shared.assetsHost"
	            }, "/js/app-docs.js?v=", {
	              t: 2,
	              r: "@shared.assetsVersion"
	            }],
	            t: 13
	          }]
	        }, " ", {
	          t: 7,
	          e: "script",
	          m: [{
	            n: "defer",
	            f: 0,
	            t: 13
	          }, {
	            n: "data-domain",
	            f: "jsdelivr.com",
	            t: 13,
	            g: 1
	          }, {
	            n: "src",
	            f: "https://datum.jsdelivr.com/js/script.js",
	            t: 13,
	            g: 1
	          }]
	        }]
	      }]
	    }],
	    n: 51,
	    l: 1
	  }],
	  e: {
	    "!_0": function (_0) {
	      return !_0;
	    },
	    "_0||\"Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.\"": function (_0) {
	      return _0 || "Optimized for JS and ESM delivery from npm and GitHub. Works with all web formats. Serving more than 150 billion requests per month.";
	    },
	    "_0||\"jsDelivr - A free, fast, and reliable CDN for JS and open source\"": function (_0) {
	      return _0 || "jsDelivr - A free, fast, and reliable CDN for JS and open source";
	    }
	  }
	};
	component$1.exports.components = {
	  "r-serialize": rSerialize
	};
	var rDocs = ractive__default["default"].extend(component$1.exports);

	var debounce = (fn, wait = 100) => {
	  let timeout;
	  return (...args) => {
	    clearTimeout(timeout);
	    timeout = setTimeout(fn, wait, ...args);
	  };
	};

	var throttle = (fn, wait = 100) => {
	  let lastCalled, timeout;
	  return (...args) => {
	    let now = Date.now();
	    if (lastCalled && now - lastCalled < wait) {
	      clearTimeout(timeout);
	      return timeout = setTimeout(fn, wait - (now - lastCalled), ...args);
	    }
	    lastCalled = now;
	    clearTimeout(timeout);
	    fn(...args);
	  };
	};

	const addManagedListener = (component, target, event, handler) => {
	  if (!target || typeof target.addEventListener !== 'function' || typeof target.removeEventListener !== 'function') {
	    console.warn('Invalid target passed to addManagedListener');
	    return;
	  }
	  target.addEventListener(event, handler);
	  if (!component || typeof component.on !== 'function') {
	    console.warn('Invalid component passed to addManagedListener');
	    return;
	  }
	  component.on('unrender', () => {
	    target.removeEventListener(event, handler);
	  });
	};
	var addManagedListener_1 = addManagedListener;
	var screenWidthListener = component => {
	  component.set('screenWidth', window.innerWidth);
	  addManagedListener(component, window, 'resize', debounce(throttle(() => component.set('screenWidth', window.innerWidth), 200)));
	};
	var stickySidebarScrollListener = component => {
	  let sidebar = document.querySelector('.page-content_side-menu');
	  if (sidebar) {
	    let top = sidebar.getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
	    let handleStickySidebarScroll = () => {
	      let y = document.scrollingElement.scrollTop;
	      let currentSidebarTop = sidebar.getBoundingClientRect().top;
	      if (currentSidebarTop <= 20 && currentSidebarTop >= 0 || y > top) {
	        sidebar.setAttribute('style', 'position: sticky; top: 20px');
	      } else {
	        sidebar.removeAttribute('style');
	      }
	    };
	    addManagedListener(component, window, 'scroll', handleStickySidebarScroll);
	    handleStickySidebarScroll();
	  }
	};
	var listeners = {
	  addManagedListener: addManagedListener_1,
	  screenWidthListener: screenWidthListener,
	  stickySidebarScrollListener: stickySidebarScrollListener
	};

	var component = {
	  exports: {}
	};
	component.exports = {
	  data() {
	    return {
	      title: 'jsDelivr API'
	    };
	  },
	  computed: {
	    readStyle() {
	      return this.get('screenWidth') < 768 ? 'view' : 'read';
	    }
	  },
	  onrender() {
	    if (!ractive__default["default"].isServer) {
	      this.set('screenWidth', innerWidth);
	      listeners.screenWidthListener(this);
	      this.find('rapi-doc').addEventListener('before-render', () => {
	        this.set('loaded', true);
	      });
	    }
	  }
	};
	component.exports.template = {
	  v: 4,
	  t: [{
	    t: 7,
	    e: "r-docs",
	    m: [{
	      n: "noYield",
	      f: [{
	        t: 2,
	        r: "noYield"
	      }],
	      t: 13
	    }, {
	      n: "title",
	      f: [{
	        t: 2,
	        r: "title"
	      }],
	      t: 13
	    }, {
	      n: "description",
	      f: [{
	        t: 2,
	        r: "description"
	      }],
	      t: 13
	    }],
	    f: [{
	      t: 7,
	      e: "style",
	      f: ["\t\t", {
	        t: 4,
	        f: ["\n\t\t\t[slot] {\n\t\t\t\tdisplay: none;\n\t\t\t}\n"],
	        n: 51,
	        r: "loaded"
	      }, "\t"]
	    }, " ", {
	      t: 7,
	      e: "c-notification"
	    }, " ", {
	      t: 7,
	      e: "c-header",
	      m: [{
	        n: "useWhiteLogos",
	        f: "true",
	        t: 13,
	        g: 1
	      }, {
	        n: "additionalClasses",
	        f: "header-with-dark-bg header-fw-docs",
	        t: 13,
	        g: 1
	      }]
	    }, " ", {
	      t: 4,
	      f: [{
	        t: 7,
	        e: "rapi-doc",
	        m: [{
	          n: "spec-url",
	          f: [{
	            t: 2,
	            r: "@shared.apiDocsHost"
	          }, "/v1/spec.yaml"],
	          t: 13
	        }, {
	          n: "id",
	          f: "thedoc",
	          t: 13,
	          g: 1
	        }, {
	          n: "theme",
	          f: "light",
	          t: 13,
	          g: 1
	        }, {
	          n: "load-fonts",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "render-style",
	          f: [{
	            t: 2,
	            r: "readStyle"
	          }],
	          t: 13
	        }, {
	          n: "regular-font",
	          f: "Lexend, sans-serif",
	          t: 13,
	          g: 1
	        }, {
	          n: "mono-font",
	          f: "'Source Code Pro', monospace",
	          t: 13,
	          g: 1
	        }, {
	          n: "show-header",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-search",
	          f: "true",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-advanced-search",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-spec-url-load",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-spec-file-load",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-spec-file-download",
	          f: "true",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-server-selection",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-authentication",
	          f: "false",
	          t: 13,
	          g: 1
	        }, {
	          n: "schema-description-expanded",
	          f: "true",
	          t: 13,
	          g: 1
	        }, {
	          n: "match-type",
	          f: "includes",
	          t: 13,
	          g: 1
	        }, {
	          n: "allow-schema-description-expand-toggle",
	          f: "false",
	          t: 13,
	          g: 1
	        }],
	        f: []
	      }],
	      n: 50,
	      r: "screenWidth"
	    }]
	  }]
	};
	component.exports.components = {
	  "c-header-gradient": headerGradient,
	  "c-notification": notification,
	  "c-footer": footer,
	  "c-header": header,
	  "r-docs": rDocs
	};
	var data_jsdelivr_com = ractive__default["default"].extend(component.exports);

	Ractive.DEBUG = location.hostname === 'localhost';
	let app = {
	  config: {}
	};
	app.router = new Ractive.Router({
	  el: '#page',
	  data() {
	    return {
	      app
	    };
	  }
	});
	let routerDispatch = Ractive.Router.prototype.dispatch;
	Ractive.Router.prototype.dispatch = function (...args) {
	  routerDispatch.apply(this, args);
	  if (!app.router.route.view) {
	    return;
	  }
	  return this;
	};
	app.router.addRoute('/docs/data.jsdelivr.com', data_jsdelivr_com);
	_.onDocumentReady(() => {
	  let state = {};
	  let ractive = new Ractive();
	  ractive.set('@shared.app', app);
	  ractive.set('@shared.escape', escape);
	  function escape(string) {
	    string.replace(/</g, '\\u003c').replace(/>/g, '\\u003e').replace(/\u2028/g, '\\u2028').replace(/\u2029/g, '\\u2029');
	  }
	  try {
	    let shared = JSON.parse(document.querySelector('#ractive-shared').innerHTML.trim());
	    if (shared) {
	      Object.keys(shared).forEach(key => {
	        ractive.set(`@shared.${key}`, shared[key]);
	      });
	    }
	  } catch {}
	  try {
	    state = JSON.parse(document.querySelector('#ractive-data').innerHTML.trim());
	  } catch {}
	  app.router.init({
	    noScroll: true,
	    state
	  });

	  // open navbar dropdowns on hover
	  $(document).on('mouseenter', '.navbar .dropdown', e => setTimeout(() => $(e.target).closest('.navbar-collapse').css('position') !== 'absolute' && $(e.target).closest('.dropdown:not(.open)').find('.dropdown-toggle').dropdown('toggle'))).on('mouseleave', '.navbar .dropdown', e => setTimeout(() => $(e.target).closest('.navbar-collapse').css('position') !== 'absolute' && $(e.target).closest('.dropdown.open').find('.dropdown-toggle').dropdown('toggle')));
	});
	var appDocs = app;

	return appDocs;

}));
